{
	"language": {
		"select": "เลือกภาษา",
		"sectionTitle": "ภาษา",
		"changeSuccess": "เปลี่ยนภาษาเรียบร้อยแล้ว"
	},
	"assistant": {
		"composer": {
			"placeholder": "ถาม {{assistantName}}",
			"disclaimer": "{{assistantName}} อาจให้ข้อมูลผิดพลาดได้ กรุณาตรวจสอบข้อมูลสำคัญ"
		},
		"greeting": {
			"initialMessage": "👋 สวัสดี ฉันคือผู้ช่วยการเรียนรู้ **{{assistantName}}** ฉันอยู่ที่นี่เพื่อช่วยให้คุณเตรียมตัวสำหรับ**{{context}}**ได้ดียิ่งขึ้น มาเจาะลึกข้อที่คุณตอบเกี่ยวกับ**{{topic}}**กัน",
			"starter": "สวัสดี ฉันคือ **{{assistantName}}** ให้ช่วยอะไรดี"
		},
		"chips": {
			"askYourOwn": "ถามคำถามของคุณเอง",
			"askFollowUp": "ถามคำถามต่อเนื่อง"
		},
		"emptyState": {
			"title": "{{assistantName}} คือผู้ช่วยการเรียนรู้ที่ขับเคลื่อนด้วย AI ของคุณ",
			"contextSubtitle": "ถามอะไรก็ได้ที่เกี่ยวกับ{{context}}",
			"activateSubtitle": "{{assistantName}} จะพร้อมใช้งานหลังจากคุณตอบคำถามแล้ว"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "ฝึกฝนแบบเร่งด่วน",
			"examInfo": {
				"subtitle": {
					"setExamDate": "ตั้งวันสอบ",
					"examDateWithValue": "วันสอบ: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "ยังปรับปรุงได้อีก",
				"itsAwesome": "ยอดเยี่ยมมาก"
			},
			"title": "คุณกำลังไปได้สวย!",
			"body": "เราดีใจที่เห็นความตั้งใจในการเรียนของคุณ! ประสบการณ์การใช้แอปจนถึงตอนนี้เป็นอย่างไรบ้าง ช่วยแบ่งปันความคิดเห็นผ่านการรีวิวได้ไหม",
			"cta": "ไว้ทีหลัง"
		},
		"actions": {
			"studyWeak": "เน้นจุดที่ยังอ่อน",
			"viewProgress": "ดูความคืบหน้าของคุณ",
			"seeRank": "ตรวจสอบอันดับของคุณ",
			"seeRankings": "ดูกระดานผู้นำ",
			"unlock": "ปลดล็อกเนื้อหาพรีเมียม",
			"unlockTooltip": "ปลดล็อกเนื้อหาพรีเมียมเพื่อเข้าถึงฟีเจอร์พิเศษและสื่อการเรียนขั้นสูง",
			"startCustomSession": "สร้างเซสชันแบบกำหนดเอง",
			"startCustomSessionTooltip": "เริ่มเซสชันฝึกฝนแบบกำหนดเองเพื่อเน้นเฉพาะจุดที่คุณต้องการ",
			"takeDiagnostic": "ทำแบบทดสอบวัดระดับ",
			"takeDiagnosticTooltip": "ทำแบบทดสอบวัดระดับเพื่อประเมินระดับปัจจุบันและปรับแผนการเรียนให้เหมาะกับคุณ",
			"viewDiagnostic": "ดูผลแบบทดสอบวัดระดับ",
			"viewDiagnosticTooltip": "ดูผลแบบทดสอบวัดระดับเพื่อดูจุดแข็งและจุดที่ควรพัฒนา",
			"viewPodcasts": "ฟังพอดแคสต์",
			"viewPodcastsTooltip": "เข้าถึงพอดแคสต์เพื่อการศึกษาเพื่อเสริมประสบการณ์การเรียนรู้ของคุณ",
			"upgradeToPremium": "อัปเกรดเป็นพรีเมียม",
			"upgradeToPremiumTooltip": "อัปเกรดเป็นพรีเมียมเพื่อเข้าถึงเนื้อหาและฟีเจอร์ทั้งหมด",
			"extendAccess": "ขยายระยะเวลาการใช้งาน",
			"extendAccessTooltip": "ขยายระยะเวลาการเข้าถึงเนื้อหาและฟีเจอร์พรีเมียมของคุณ",
			"setExamDate": "ตั้งวันสอบ",
			"setExamDateTooltip": "ตั้งวันสอบเพื่อติดตามความคืบหน้าและเตรียมตัวสอบ"
		},
		"exam": {
			"daysAgo_one": "{{count}} วันที่แล้ว",
			"daysAgo_other": "{{count}} วันที่แล้ว",
			"untilExam_one": "อีก {{count}} วันถึงวันสอบ",
			"untilExam_other": "อีก {{count}} วันถึงวันสอบ",
			"isToday": "วันนี้คือวันสอบ!"
		},
		"stats": {
			"mastery": "ความเชี่ยวชาญ",
			"completed_one": "ข้อที่ตอบแล้ว",
			"completed_other": "ข้อที่ตอบแล้ว",
			"completedValue": "{{count}}",
			"xpEarned": "XP ที่ได้รับ",
			"xpEarnedValue": "{{value}}",
			"accuracy": "ความแม่นยำ",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "ระดับความสามารถ{{skill, lowercase}}โดยประมาณของคุณคือ {{level, lowercase}}",
			"itemsAnsweredTooltip": "จำนวนข้อทั้งหมดที่คุณตอบไปแล้ว",
			"responsesAnsweredTooltip": "จำนวนคำตอบทั้งหมดที่คุณส่งไปแล้ว",
			"examDateTooltip": "วันสอบของคุณคือ {{date}}",
			"skillCta": {
				"diagnostic": "แบบทดสอบวัดระดับ",
				"practice": "ฝึกฝน"
			}
		},
		"menu": {
			"settings": "การตั้งค่า",
			"profile": "โปรไฟล์"
		},
		"diagnostics": {
			"title": "แบบทดสอบวัดระดับ",
			"free": "ฟรี",
			"duration": "{{count}} {{item}} • {{minutes}} นาที",
			"completed": "ทำ {{count}} {{item}} เสร็จแล้ว",
			"start": "เริ่ม",
			"viewReport": "ดูรายงาน",
			"resume": "ทำต่อ"
		},
		"practiceTests": {
			"title": "ข้อสอบเสมือนจริง",
			"sectionalTestsTitle": "ข้อสอบรายส่วน",
			"diagnosticAssessmentsTitle": "แบบทดสอบวัดระดับ",
			"premiumChipTooltip": "ข้อสอบเสมือนจริงแบบพรีเมียมความยาวเต็มรูปแบบสำหรับการสอบ {{examName}}",
			"freeChipTooltip": "{{label}}สำหรับการสอบ {{examName}}",
			"freeChipTooltipDefault": "แบบทดสอบวัดระดับฟรีสำหรับการสอบ {{examName}}",
			"completedDescription_one": "{{count}} ข้อ • {{date}}",
			"completedDescription_other": "{{count}} ข้อ • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} ข้อ • เหลืออีก {{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}} ข้อ • เหลืออีก {{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} ข้อ • เหลืออีก {{timeRemaining}} • เริ่มเมื่อ: {{startedOn}} • สิ้นสุด: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} ข้อ • เหลืออีก {{timeRemaining}} • เริ่มเมื่อ: {{startedOn}} • สิ้นสุด: {{endsOn}}",
			"notStartedDescription_one": "{{count}} ข้อ • {{duration}}",
			"notStartedDescription_other": "{{count}} ข้อ • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} ข้อ • {{duration}} • สิ้นสุด: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} ข้อ • {{duration}} • สิ้นสุด: {{endsOn}}",
			"viewResultsCta": "ดูผลลัพธ์",
			"startCta": "เริ่ม",
			"chips": {
				"items_one": "{{count}} ข้อ",
				"items_other": "{{count}} ข้อ",
				"progress_one": "{{attempted}}/{{count}} ข้อ",
				"progress_other": "{{attempted}}/{{count}} ข้อ",
				"timeRemaining": "เหลืออีก {{time}}",
				"startedOn": "เริ่มเมื่อ: {{date}}",
				"endsOn": "สิ้นสุด: {{date}}",
				"timeLeft": "เหลืออีก {{time}}"
			},
			"status": {
				"notStarted": {
					"label": "ยังไม่เริ่ม",
					"section": "ข้อสอบเสมือนจริงความยาวเต็มรูปแบบ"
				},
				"inProgress": {
					"label": "กำลังทำอยู่",
					"section": "กำลังทำอยู่"
				},
				"completed": {
					"label": "เสร็จสิ้น",
					"section": "เสร็จสิ้น"
				},
				"legacyReports": {
					"label": "รายงานรุ่นเก่า",
					"section": "รายงานรุ่นเก่า"
				},
				"migratedReports": {
					"label": "รายงานที่ย้ายข้อมูลแล้ว",
					"section": "รายงานที่ย้ายข้อมูลแล้ว"
				}
			}
		},
		"skills": {
			"title": "ทักษะ",
			"unlockSubtitle": "ปลดล็อกพรีเมียมเพื่อฝึกฝน",
			"startCta": "ฝึกฝน",
			"freeItemsIncludedChip": "รวมข้อสอบฟรี",
			"freeItemsAnsweredSubtitle_one": "ตอบแล้ว {{answered, number}} จากข้อสอบฟรี {{count, number}} ข้อ",
			"freeItemsAnsweredSubtitle_other": "ตอบแล้ว {{answered, number}} จากข้อสอบฟรี {{count, number}} ข้อ",
			"progressCards": {
				"questionTypesTitle": "ผลงานตามประเภทคำถาม",
				"questionTypesSubtitle": "คะแนนของคุณในคำถามประเภทต่าง ๆ ของ{{skill}}",
				"proficiencyTitle": "ผลงานตามระดับความสามารถ",
				"proficiencySubtitle": "ความคืบหน้าของคุณในแต่ละระดับของ{{skill}}",
				"questionTypeCardSubtitle": "ความคืบหน้าตามระดับความสามารถ",
				"bySkillTitle": "ผลงานตามทักษะ",
				"bySkillSubtitle": "ความคืบหน้าโดยรวมของทุกทักษะ",
				"needsImprovementTitle": "จุดที่ควรพัฒนา",
				"needsImprovementSubtitle": "หัวข้อที่ควรเน้นต่อไป",
				"skillPerformanceTitle": "ผลงาน{{skill}}",
				"skillPerformanceSubtitle": "ความคืบหน้าตามประเภทคำถามและระดับความสามารถ",
				"skillLevelSubtitle": "ความคืบหน้าของคุณในระดับทักษะนี้",
				"skillsPerformanceTitle": "ผลงานด้านทักษะ",
				"performanceByItemDifficulty": "ผลงานตามระดับความยากของข้อสอบ",
				"performanceByItemDifficultyCaption_one": "แสดงความแม่นยำของคุณตามระดับความสามารถ โดยอ้างอิงจาก {{count}} ข้อที่ตอบไปแล้ว",
				"performanceByItemDifficultyCaption_other": "แสดงความแม่นยำของคุณตามระดับความสามารถ โดยอ้างอิงจาก {{count}} ข้อที่ตอบไปแล้ว",
				"questionTypePartSubtitle": "{{skill}} · ส่วนที่ {{part}}",
				"activityGoalTitle": "กิจกรรมและความคืบหน้าสู่เป้าหมาย",
				"recentActivityTitle": "กิจกรรมล่าสุด",
				"goalProgressTitle": "ความคืบหน้าสู่เป้าหมาย",
				"goalProgressSubtitle": "คะแนนรวม · 7 สัปดาห์ที่ผ่านมา",
				"goalProgressInsight": "คุณกำลังพัฒนาขึ้นอย่างต่อเนื่อง คุณยังห่างจากเป้าหมายอยู่ 14 คะแนน และน่าจะถึงเป้าหมายได้ในอีกประมาณ 3 สัปดาห์",
				"goalProgressActualLabel": "คะแนนของคุณ",
				"goalProgressTargetLabel": "เป้าหมาย",
				"goalProgressTimeAxisLabel": "เวลา",
				"goalProgressScoreAxisLabel": "ความคืบหน้าโดยรวม",
				"statusTitle": "สถานะของคุณ",
				"diagnosticsTitle": "แบบทดสอบวัดระดับ",
				"diagnosticsReviewCta": "ทบทวน",
				"strengthsFocusTitle": "จุดแข็งและจุดที่ควรเน้น",
				"strengthsFocusSubtitle": "จุดที่คุณแข็งแกร่งที่สุด และประเภทคำถามที่ต้องฝึกฝนเพิ่ม",
				"strengthsLabel": "จุดแข็ง",
				"focusAreasLabel": "จุดที่ควรเน้น",
				"recommendedNextStepLabel": "ขั้นตอนถัดไปที่แนะนำ",
				"recommendedNextStepCta": "เริ่ม",
				"practiceTestsViewMore": "ดูข้อสอบทั้งหมด {{count}} ชุด"
			},
			"proficiencySection": "ฝึกฝนตามระดับความสามารถ"
		},
		"recommendedTasks": {
			"sectionTitle": "แนะนำสำหรับคุณ",
			"startSessionAction": "ฝึกฝน",
			"resumeAction": "ทำต่อ",
			"reviewResultsAction": "ทบทวนผลลัพธ์",
			"startTestAction": "เริ่มทำข้อสอบ",
			"activeTestBody": "ทำแบบประเมินที่ค้างอยู่ให้เสร็จ",
			"completedTestBody": "ทบทวนผลงานและคำตอบของคุณ",
			"diagnosticBody": "ทำ{{label}}เพื่อทำความคุ้นเคยกับรูปแบบข้อสอบ",
			"diagnosticDefaultLabel": "แบบทดสอบวัดระดับฟรี",
			"practiceTestBody": "ประเมินความพร้อมสอบของคุณด้วยข้อสอบแบบจับเวลา",
			"sectionalTestBody": "ทำข้อสอบแบบเจาะจงเพื่อฝึกทักษะ {{skills}} ของคุณ",
			"weakSkillTitle": "เสริม{{skill}}ของคุณ",
			"weakSkillBody": "ฝึก{{questionType}} โดยเน้นส่วนที่คุณยังไม่เชี่ยวชาญ",
			"strongSkillTitle": "รักษา{{skill}}ให้คมอยู่เสมอ",
			"strongSkillBody": "คุณทำได้ดีอยู่แล้ว ฝึก{{questionType}}สั้น ๆ เพื่อรักษาระดับไว้",
			"mixedSkillTitle": "เติมเต็ม{{skill}}ของคุณ",
			"mixedSkillBody": "ชุดผสมครอบคลุม {{questionTypes}} โดยเน้นส่วนที่คุณพลาดไป",
			"higherDifficultySkillTitle": "ก้าวสู่ระดับ {{proficiency}}",
			"higherDifficultySkillBody": "คุณทำ{{questionType}}ในระดับนี้ได้แล้ว ชุดนี้จะยากขึ้นอีกขั้น",
			"itemsChip_one": "{{count}} ข้อ",
			"itemsChip_other": "{{count}} ข้อ",
			"timeRemainingChip": "เหลืออีก {{minutes}} นาที",
			"timeRemainingChipCompact": "{{minutes}} นาที"
		},
		"itemTypes": {
			"answeredLabel_one": "ข้อที่ตอบแล้ว",
			"answeredLabel_other": "ข้อที่ตอบแล้ว",
			"answeredAll": "ทั้งหมด",
			"answeredPartial": "{{answered}} จาก {{total}}",
			"cardSubtitleComplete": "ตอบครบทุกข้อแล้ว",
			"cardSubtitlePartial": "ตอบแล้ว {{attempted}} จาก {{total}} ข้อ",
			"cardSubtitleResponses_one": "{{count}} คำตอบ",
			"cardSubtitleResponses_other": "{{count}} คำตอบ",
			"responsesLabel_one": "คำตอบ",
			"responsesLabel_other": "คำตอบ",
			"detail": {
				"skillLabel": "ทักษะ",
				"estimatedLevelLabel": "ระดับโดยประมาณ"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} คำตอบ",
			"responseCount_other": "{{count, number}} คำตอบ"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "รวมข้อสอบฝึกหัด {{count, number}} ข้อให้ใช้ฟรี",
			"freeContentBannerTitle_other": "รวมข้อสอบฝึกหัด {{count, number}} ข้อให้ใช้ฟรี",
			"freeContentBannerBody": "ฝึกทำข้อสอบ{{skills}}ที่คัดสรรมาได้ทุกเมื่อ อัปเกรดเพื่อปลดล็อกชุดการเรียนแบบเต็ม",
			"freeContentBannerCta": "เริ่มฝึกฝนฟรี",
			"freeSampleBanner": {
				"body_one": "ฝึกทำข้อที่คัดสรรจาก{{categories}}ได้ทุกเมื่อ อัปเกรดเพื่อปลดล็อกอีก {{count, number}} ข้อ",
				"body_other": "ฝึกทำข้อที่คัดสรรจาก{{categories}}ได้ทุกเมื่อ อัปเกรดเพื่อปลดล็อกอีก {{count, number}} ข้อ",
				"moreTags": "อีก {{count, number}} {{label}}",
				"cta": "อัปเกรด"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "ดูว่าคุณอยู่ตรงไหนเมื่อเทียบกับคนอื่น"
		},
		"home": {
			"title": "หน้าแรก"
		},
		"podcasts": {
			"description": "ฟังพอดแคสต์ด้านออร์โธปิดิกส์ที่นำโดยผู้เชี่ยวชาญ"
		},
		"more": {
			"title": "การตั้งค่าเพิ่มเติม"
		}
	},
	"emptyState": {
		"progress": {
			"title": "ยังไม่มีความคืบหน้าในการเรียน",
			"subtitle": "เมื่อคุณเริ่มเรียน ความคืบหน้าจะแสดงที่นี่",
			"cta": "เริ่มเรียนเลย"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "เกิดข้อผิดพลาด",
			"body": "สร้างเซสชันไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "ขั้นสูง",
			"highIntermediate": "ระดับกลาง",
			"intermediate": "ระดับกลาง",
			"basic": "ระดับพื้นฐาน",
			"none": "ยังไม่ได้ตอบ",
			"high": "เชี่ยวชาญแล้ว",
			"medium": "ใกล้สำเร็จแล้ว",
			"low": "ต้องปรับปรุง"
		}
	},
	"leaderboard": {
		"you": "นี่คือคุณ",
		"periods": {
			"all_time": "ตลอดกาล",
			"month": "เดือนนี้",
			"week": "สัปดาห์นี้"
		},
		"scope": {
			"global": "ทั่วโลก",
			"friends": "เพื่อน"
		},
		"friends": {
			"soon": "เร็ว ๆ นี้",
			"comingSoonTitle": "กระดานผู้นำของเพื่อน",
			"comingSoonBadge": "เร็ว ๆ นี้",
			"comingSoonDescription": "ติดตามความคืบหน้าเทียบกับเพื่อน ๆ และดูว่าใครเป็นที่หนึ่งของกลุ่ม"
		},
		"error": {
			"title": "การเชื่อมต่อผิดพลาด",
			"description": "ไม่สามารถโหลดกระดานผู้นำได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่อีกครั้ง",
			"tryAgain": "ลองอีกครั้ง"
		},
		"empty": {
			"title": "ยังไม่มีผู้นำ",
			"description": "อันดับจะอัปเดตเมื่อมีผู้เรียนมากขึ้น มาเป็นคนแรกที่ได้รับ XP และครองอันดับหนึ่งกันเลย!",
			"startLearning": "เริ่มเรียนเลย"
		},
		"topPerformers": "ผู้ทำคะแนนสูงสุด",
		"yourPosition": "อันดับของคุณ",
		"rankings": "อันดับ",
		"rankingsRange": "อันดับ • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "รับ XP เพื่อเข้าร่วมการจัดอันดับ!",
			"description": "เริ่มเซสชันการเรียนเพื่อรับคะแนนแรกและเข้าร่วมกระดานผู้นำ",
			"cta": "เริ่มเซสชันแรกของคุณ"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "คุณ",
		"podium": {
			"first": "อันดับ 1",
			"second": "อันดับ 2",
			"third": "อันดับ 3"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>เพื่อแซงอันดับ {{rank}}</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>จากการขึ้นโพเดียม</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "บทเรียน",
			"statusFilter": {
				"all": "ทั้งหมด",
				"inProgress": "กำลังเรียน",
				"notStarted": "ยังไม่เริ่ม",
				"completed": "เรียนจบแล้ว"
			},
			"card": {
				"openCta": "เปิด",
				"resumeCta": "เรียนต่อ",
				"viewResultsCta": "ดูผลลัพธ์",
				"duration_one": "{{count}} นาที",
				"duration_other": "{{count}} นาที"
			},
			"viewToggle": {
				"list": "มุมมองรายการ",
				"grid": "มุมมองตาราง"
			},
			"empty": {
				"filteredTitle": "ไม่มีบทเรียนที่ตรงกับตัวกรองนี้",
				"filteredSubtitle": "ลองใช้ตัวกรองสถานะอื่น",
				"filteredCta": "แสดงทั้งหมด",
				"noneTitle": "ไม่พบบทเรียน",
				"noneSubtitle": "ลองนำตัวกรองออกหรือเริ่มการค้นหาใหม่",
				"noneCta": "รีเซ็ตทั้งหมด"
			}
		},
		"home": {
			"hero": {
				"greeting": "ยินดีต้อนรับ {{name}}!",
				"greetingNoName": "ยินดีต้อนรับ!"
			},
			"stats": {
				"modulesDone": "โมดูลที่เสร็จแล้ว",
				"dayStreak": "สตรีครายวัน",
				"minutesToday": "นาทีวันนี้"
			},
			"suggested": {
				"title": "แนะนำสำหรับคุณ",
				"openModuleCta": "เปิดโมดูล",
				"status": {
					"ready": "พร้อม",
					"next": "ถัดไป"
				}
			},
			"all": {
				"title": "บทเรียนทั้งหมด"
			},
			"emptyState": {
				"title": "ยังไม่มีบทเรียน",
				"subtitle": "กลับมาดูบทเรียนใหม่เร็ว ๆ นี้"
			},
			"card": {
				"duration_one": "{{count}} นาที",
				"duration_other": "{{count}} นาที"
			}
		},
		"overview": {
			"header": {
				"title": "ภาพรวม"
			},
			"startCta": "เริ่มเรียน",
			"objectives": {
				"title": "เป้าหมายการเรียนรู้"
			}
		},
		"detail": {
			"takeQuizCta": "ทำแบบทดสอบ",
			"progress": {
				"label": "ความคืบหน้าของโมดูล"
			},
			"activities": {
				"title": "กิจกรรม",
				"completedCount": "เสร็จแล้ว {{completed}} จาก {{total}}"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "ข้อมูลเชิงลึกความคืบหน้า"
			},
			"milestones": {
				"title": "หมุดหมายของโมดูล",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "อ่านแล้ว"
			},
			"readTime": "อ่าน {{count}} นาที",
			"sectionBadge": {
				"label": "ตอนที่ {{number}} จาก {{total}}"
			},
			"upNext": {
				"title": "ถัดไป"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "เซสชันการเรียนแบบกำหนดเอง",
		"diagnostic": "แบบทดสอบวัดระดับ",
		"skill": "ทักษะ",
		"Proficiency": "ระดับความสามารถ",
		"Question Type": "ประเภทคำถาม",
		"mastery": "ความเชี่ยวชาญ",
		"sessionLength": "ระยะเวลาเซสชัน",
		"itemsChip_one": "{{count}} ข้อ",
		"itemsChip_other": "{{count}} ข้อ",
		"durationEstimate": "{{minutes}} นาที",
		"durationRange": "{{min}}–{{max}} นาที",
		"noItemsTooltip": "ไม่มีข้อสอบที่ตรงกับตัวกรองปัจจุบัน",
		"setCount": "{{count}} {{type}}",
		"dismiss": "ตกลง",
		"status": {
			"notAnswered": "ยังไม่ได้ตอบ",
			"needsWork": "ต้องปรับปรุง"
		},
		"itemCount": "คุณจะทำข้อสอบ {{count}} ข้อจาก {{topics}}",
		"start": "เริ่มเซสชัน",
		"configuringSession": "กำลังตั้งค่าเซสชัน",
		"fetchingContent": "กำลังดึงเนื้อหา",
		"preparingMaterials": "กำลังเตรียมสื่อการเรียน",
		"almostThere": "ใกล้เสร็จแล้ว",
		"startingSession": "กำลังเริ่มเซสชัน",
		"playIcon": "play-outline",
		"infoText": "คุณจะทำ **{{numItems}}** {{itemCount}} ซึ่งใช้เวลาประมาณ **{{timeString}}**",
		"customSummary": {
			"message": "เรียน $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) จาก {{topics}}",
			"messageWithMastery": "เรียน $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) จาก {{topics}} โดยเน้น{{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}})",
			"messageAllMasteryLevels": "เรียน $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) จาก {{topics}} ครอบคลุมทุกระดับความเชี่ยวชาญ",
			"itemCount_one": "{{count}} ข้อ",
			"itemCount_other": "{{count}} ข้อ",
			"masteryLevelCount_one": "ระดับความเชี่ยวชาญ",
			"masteryLevelCount_other": "ระดับความเชี่ยวชาญ",
			"allTopics": "ทั้ง {{count}} หัวข้อ",
			"more": "อีก {{count}} รายการ",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "ฝึกฝนแบบเร่งด่วน",
			"recommended": "แนะนำ",
			"custom": "กำหนดเอง",
			"selectHelper": "แตะที่เซสชันเพื่อเลือก แล้วเริ่มได้เมื่อคุณพร้อม",
			"emptyRecommended": "ขณะนี้ยังไม่มีเซสชันที่แนะนำ",
			"summary": "เรียน {{count}} ข้อจาก{{skill}} ใช้เวลาประมาณ {{minutes}} นาที",
			"summary_questionType": "เรียน {{count}} ข้อจาก{{skill}} หัวข้อ {{questionType}} ใช้เวลาประมาณ {{minutes}} นาที",
			"duration": "{{minutes}} นาที",
			"levelSessions": {
				"rapidRecall": "ทบทวนแบบรวดเร็ว",
				"purposefulPractice": "ฝึกฝนอย่างมีเป้าหมาย",
				"focusFlow": "โฟกัสต่อเนื่อง",
				"itemsLabel": "ข้อสอบระดับ {{level}}",
				"itemsLabelGeneric": "ข้อสอบ",
				"summaries": {
					"rapidRecall": "ทำความคุ้นเคยอย่างรวดเร็วกับข้อสอบระดับ {{level}} จำนวน {{count}} ข้อที่คุณยังไม่ได้ตอบ เพื่อขยายความครอบคลุมอย่างต่อเนื่อง ใช้เวลาประมาณ {{minutes}} นาที",
					"purposefulPractice": "ทำข้อสอบระดับ {{level}} จำนวน {{count}} ข้อที่จัดสัดส่วนอย่างสมดุล โดยเริ่มจากเนื้อหาที่ต้องปรับปรุงมากที่สุด ใช้เวลาประมาณ {{minutes}} นาที",
					"focusFlow": "เสริมจุดอ่อนของคุณด้วยข้อสอบระดับ {{level}} จำนวน {{count}} ข้อที่คุณตอบแล้วได้ความเชี่ยวชาญระดับต่ำหรือปานกลาง ใช้เวลาประมาณ {{minutes}} นาที"
				},
				"summariesGeneric": {
					"rapidRecall": "ทำความคุ้นเคยอย่างรวดเร็วกับข้อสอบ {{count}} ข้อที่คุณยังไม่ได้ตอบ เพื่อขยายความครอบคลุมอย่างต่อเนื่อง ใช้เวลาประมาณ {{minutes}} นาที",
					"purposefulPractice": "ทำข้อสอบ {{count}} ข้อที่จัดสัดส่วนอย่างสมดุล โดยเริ่มจากเนื้อหาที่ต้องปรับปรุงมากที่สุด ใช้เวลาประมาณ {{minutes}} นาที",
					"focusFlow": "เสริมจุดอ่อนของคุณด้วยข้อสอบ {{count}} ข้อที่คุณตอบแล้วได้ความเชี่ยวชาญระดับต่ำหรือปานกลาง ใช้เวลาประมาณ {{minutes}} นาที"
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium",
			"durationSelector": {
				"title": "ระยะเวลา"
			}
		}
	},
	"skillDetail": {
		"diagnosticInsight": "เพื่อปรับประสบการณ์การเรียนให้เหมาะกับคุณโดยเฉพาะ ให้เริ่มต้นด้วยแบบทดสอบวัดระดับ ผลลัพธ์จากการวัดระดับของคุณจะถูกนำไปใช้สร้างแผนการเรียนของคุณ"
	},
	"premium": {
		"chip": "พรีเมียม",
		"upgrade": "อัปเกรดเป็นพรีเมียม",
		"unlockTitle": "ปลดล็อกประสบการณ์ {{productName}} แบบครบถ้วน",
		"unlockDescription": "ปลดล็อกการฝึกฝนเฉพาะบุคคลที่ออกแบบมาให้เหมาะกับเวลาเตรียมตัวที่คุณเหลืออยู่",
		"readyTitle": "เตรียมพร้อมสำหรับการสอบวันที่ {{date}}",
		"tip": "พรีเมียมช่วยกำหนดจุดโฟกัสเฉพาะสำหรับคุณ โดยระบุว่าควรฝึกอะไรต่อไป และปรับแผนการเรียนให้เหมาะสมเมื่อคุณพัฒนาขึ้น"
	},
	"purchase": {
		"success": {
			"headerTitle": "ขอบคุณสำหรับการสั่งซื้อ!",
			"accessGranted": "เปิดสิทธิ์การใช้งาน{{name}}ของคุณเรียบร้อยแล้ว",
			"studyPack": "ชุดการเรียน",
			"practiceTest": "ข้อสอบเสมือนจริง",
			"combo": "แพ็กรวม",
			"documentTitle": "การสั่งซื้อ",
			"summary_one": "ยินดีด้วย! **ผลิตภัณฑ์**ด้านล่างถูกปลดล็อกในบัญชีของคุณแล้ว หลังจากกด{{action}} บริบทของแอปจะเปลี่ยนไปตามการสอบ: **{{examName}}** คุณสามารถเปลี่ยนได้ทุกเมื่อในการตั้งค่าบัญชี หากต้องการเตรียมสอบรายการอื่นหรือซื้อผลิตภัณฑ์อื่น",
			"summary_other": "ยินดีด้วย! **ผลิตภัณฑ์ {{count}} รายการ**ด้านล่างถูกปลดล็อกในบัญชีของคุณแล้ว หลังจากกด{{action}} บริบทของแอปจะเปลี่ยนไปตามการสอบ: **{{examName}}** คุณสามารถเปลี่ยนได้ทุกเมื่อในการตั้งค่าบัญชี หากต้องการเตรียมสอบรายการอื่นหรือซื้อผลิตภัณฑ์อื่น",
			"unlockedDuration": "ยินดีด้วย! คุณได้ปลดล็อกการเข้าใช้งาน **{{name}}** เป็นเวลา **{{duration}}** แล้ว โดยจะหมดอายุในวันที่ **{{expiry}}**",
			"storeNote": "หมายเหตุ: ชุดการเรียนใช้งานได้ผ่านแอปมือถือของเราเท่านั้น กรุณาดาวน์โหลดแอปที่เหมาะกับอุปกรณ์ของคุณ",
			"actions": {
				"goToHome": "ไปที่หน้าแรก",
				"startDiagnostic": "เริ่ม{{label}}",
				"takeDiagnostic": "ทำ{{label}}",
				"takeFreeDiagnostic": "ทำแบบทดสอบวัดระดับฟรี",
				"diagnosticLabel": "แบบทดสอบวัดระดับ"
			}
		},
		"checkout": {
			"headerTitle": "ดำเนินการสั่งซื้อให้เสร็จสิ้น"
		},
		"paywall": {
			"studyPackDialogTitle": "อัปเกรดแผนการเรียนของคุณ",
			"defaultDialogTitle": "อัปเกรดแผนการเรียนของคุณ",
			"practiceTestDialogTitle": "ปลดล็อกข้อสอบเสมือนจริง",
			"restorePurchaseDialogTitle": "ซื้อไปแล้วใช่ไหม",
			"restorePurchaseDialogSubheadingWeb": "ถ้ายังไม่ได้ซื้อ ลองทำตามนี้:",
			"restorePurchaseDialogBody": "หากคุณซื้อผลิตภัณฑ์นี้ไปแล้วแต่ยังถูกล็อกอยู่ กรุณาลองทำตามขั้นตอนต่อไปนี้:\n\n1. ตรวจสอบว่าคุณเข้าสู่ระบบด้วยบัญชีที่ถูกต้อง\n2. ตรวจสอบว่าคุณเลือกผลิตภัณฑ์ที่ถูกต้อง\n3. ตรวจสอบว่าการสมัครสมาชิกของคุณยังไม่หมดอายุ\n4. ตรวจสอบว่าคุณเปิดใช้งานการสมัครสมาชิกแล้ว (ลองดูในกล่องจดหมายขยะ)\n5. หากคุณมีรหัสเข้าใช้งาน โปรดใช้[รหัสเข้าใช้งาน]({{baseUrl}}/redeem)\n\nหากไม่ตรงกับกรณีใดข้างต้น กรุณา**คลิกที่นี่**",
			"restorePurchaseDialogBodyWeb": "1. ตรวจสอบว่าคุณเข้าสู่ระบบด้วยอีเมลที่ถูกต้อง\n2. ตรวจสอบว่าคุณ**[เลือกการสอบ](/account/settings)**ถูกต้อง\n3. ตรวจสอบว่าการสมัครสมาชิกของคุณยังไม่หมดอายุ\n\nหากไม่ตรงกับกรณีใดข้างต้น กรุณา**ติดต่อฝ่ายสนับสนุน**",
			"accesDuration": {
				"yearPlan": "แพ็กเกจ **{{duration}}** ให้ระยะเวลาใช้งานที่ยาวนานขึ้น คุณจึงมีความยืดหยุ่นสูงสุดในการเรียนตามจังหวะของตัวเองและเตรียมสอบได้อย่างเต็มที่",
				"moreTime": "หากคิดว่าต้องใช้เวลาเตรียมตัวมากกว่านี้ ลองพิจารณาแพ็กเกจ **{{duration}}**",
				"otherPlan": "แพ็กเกจ **{{duration}}** ให้สิทธิ์ใช้งานถึง **{{expiryText}}** ซึ่งเพียงพอสำหรับการเตรียมตัว {{moreTime}}"
			},
			"actions": {
				"upgrade": "อัปเกรด",
				"unlock": "ปลดล็อกในราคา {{price}}",
				"subscribe": "สมัครสมาชิกในราคา {{price}}",
				"extendAccess": "ขยายระยะเวลาการใช้งาน",
				"accessHere": "เข้าใช้งานที่นี่",
				"redeemAccessCode": "มีรหัสเข้าใช้งานหรือไม่",
				"restorePurchase": "ซื้อไปแล้วใช่ไหม",
				"restorePurchaseWeb": "ซื้อไปแล้วหรือมีรหัสเข้าใช้งานใช่ไหม"
			},
			"subscriptionSummary": {
				"yearly": "สมัครสมาชิกรายปี • ต่ออายุอัตโนมัติ • ยกเลิกได้ทุกเมื่อ",
				"monthly": "สมัครสมาชิกรายเดือน • ต่ออายุอัตโนมัติ • ยกเลิกได้ทุกเมื่อ",
				"weekly": "สมัครสมาชิกรายสัปดาห์ • ต่ออายุอัตโนมัติ • ยกเลิกได้ทุกเมื่อ",
				"generic": "สมัครสมาชิกแบบต่ออายุอัตโนมัติ • ยกเลิกได้ทุกเมื่อ"
			},
			"planDuration": {
				"day_one": "{{count}} วัน",
				"day_other": "{{count}} วัน",
				"week_one": "{{count}} สัปดาห์",
				"week_other": "{{count}} สัปดาห์",
				"month_one": "{{count}} เดือน",
				"month_other": "{{count}} เดือน",
				"year_one": "{{count}} ปี",
				"year_other": "{{count}} ปี"
			},
			"recommendedPlan": {
				"plan": "เราแนะนำแพ็กเกจ \"**{{duration}}**\" เพื่อเตรียมตัวสอบในวันที่ **{{date}}** ได้ดีที่สุด",
				"subscription": {
					"yearly": "เราแนะนำ**การสมัครสมาชิกรายปี** เพื่อให้คุณเข้าถึงเนื้อหาได้ต่อเนื่องและเตรียมตัวสอบในวันที่ **{{date}}**",
					"monthly": "เราแนะนำ**การสมัครสมาชิกรายเดือน** เพื่อให้คุณเข้าถึงเนื้อหาได้ต่อเนื่องและเตรียมตัวสอบในวันที่ **{{date}}**",
					"weekly": "เราแนะนำ**การสมัครสมาชิกรายสัปดาห์** เพื่อให้คุณเข้าถึงเนื้อหาได้ต่อเนื่องและเตรียมตัวสอบในวันที่ **{{date}}**",
					"generic": "เราแนะนำ**การสมัครสมาชิก** เพื่อให้คุณเข้าถึงเนื้อหาได้ต่อเนื่องและเตรียมตัวสอบในวันที่ **{{date}}**"
				}
			},
			"disclaimer": "เมื่อยืนยันการสั่งซื้อ คุณจะได้รับสิทธิ์เข้าถึงเนื้อหาทั้งหมดของผลิตภัณฑ์นี้ตลอดระยะเวลาที่เลือก เมื่อครบกำหนด คุณจะไม่สามารถเข้าถึงเนื้อหาที่จำกัดสิทธิ์ได้อีก หากต้องการขยายระยะเวลาการใช้งานไม่ว่าด้วยเหตุผลใด (เช่น คุณเลื่อนวันสอบ) คุณสามารถเพิ่มระยะเวลาได้ผ่านการซื้อภายในแอปเพิ่มเติม ดูข้อมูลเพิ่มเติมได้ที่[ข้อกำหนดในการให้บริการและนโยบายความเป็นส่วนตัว](https://memorang.com/legal) ของเรา"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "อ้างอิงจาก {{numItems}} {{item}} ที่ตอบแล้วใน {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "แสดงความคืบหน้าของคุณใน {{count}} {{type}} โดยอ้างอิงจาก {{itemCount}} {{item}} ที่คุณตอบไปแล้ว"
		},
		"needsImprovement": {
			"title": "จุดที่ควรพัฒนา",
			"subtitle": "{{type}}ที่แนะนำให้คุณปรับปรุง",
			"cta": "เริ่มเรียนเลย"
		},
		"mastery": {
			"high": "เชี่ยวชาญแล้ว",
			"medium": "ใกล้สำเร็จแล้ว",
			"low": "ต้องปรับปรุง",
			"count": "ตอบแล้ว {{count}} {{item}}",
			"zeroTooltip": "ยังไม่มีข้อสอบระดับ{{label}}จากทั้งหมด {{total}} ข้อที่ตอบแล้ว",
			"highTooltip": "คุณเชี่ยวชาญแล้ว {{count}} จาก {{total}} {{item}} ที่ตอบไปแล้ว",
			"mediumTooltip": "คุณกำลังพัฒนาขึ้นใน {{count}} จาก {{total}} {{item}} ที่ตอบไปแล้ว",
			"lowTooltip": "คุณต้องฝึกเพิ่มอีกใน {{count}} จาก {{total}} {{item}} ที่ตอบไปแล้ว"
		},
		"stats": {
			"completion": "ความสำเร็จ",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "คุณทำเสร็จแล้ว {{completed}} จาก {{total}} {{item}}"
		},
		"exams": {
			"title": "ข้อสอบเสมือนจริง",
			"subtitle_one": "อ้างอิงจากแบบประเมินที่ทำเสร็จแล้ว {{count}} ชุด",
			"subtitle_other": "อ้างอิงจากแบบประเมินที่ทำเสร็จแล้ว {{count}} ชุด"
		},
		"summary": {
			"title": "สรุปการเรียนรู้",
			"subtitle": "อ้างอิงจาก {{count}} {{item}} ที่ตอบแล้ว",
			"tooltip": "สรุปนี้แสดงระดับความเชี่ยวชาญและความคืบหน้าของคุณจากทั้งหมด {{count}} {{item}} ผลงานของคุณวัดจากเซสชันการฝึกฝน แบบประเมิน และกิจกรรมการเรียน",
			"mastery": "ความเชี่ยวชาญ",
			"quickStats": "สถิติโดยย่อ"
		},
		"languageLearning": {
			"proficiencyCardTitle": "ระดับความสามารถ{{skill}}",
			"proficiencyCardTooltip": "ขณะนี้ผลงาน{{skill, lowercase}}ของคุณอยู่ในระดับ {{level, lowercase}}",
			"itemTypesCardSubtitle_one": "ข้อสอบ {{count}} ประเภท",
			"itemTypesCardSubtitle_other": "ข้อสอบ {{count}} ประเภท",
			"itemTypesCardTitle": "ข้อสอบ{{skill}}",
			"itemTypeLevelTooltip": "ในคำถามประเภท “{{itemType}}” ขณะนี้ผลงาน{{skill, lowercase}}ของคุณอยู่ในระดับ {{level, lowercase}}",
			"itemTypesFallbackTitle": "ประเภทข้อสอบ",
			"itemTypesEmptyTitle": "ไม่พบประเภทข้อสอบ",
			"itemTypesEmptySubtitle": "เราไม่พบประเภทข้อสอบสำหรับทักษะนี้ กรุณากลับไปที่ความคืบหน้าแล้วลองใหม่อีกครั้ง",
			"itemTypesEmptyCta": "กลับไปที่ความคืบหน้า",
			"notAnswered": "ยังไม่ได้ตอบ",
			"answeredSubtitle_one": "อ้างอิงจาก {{count}} ข้อที่ตอบแล้ว",
			"answeredSubtitle_other": "อ้างอิงจาก {{count}} ข้อที่ตอบแล้ว",
			"responsesSubtitle_one": "อ้างอิงจาก {{count}} คำตอบ",
			"responsesSubtitle_other": "อ้างอิงจาก {{count}} คำตอบ",
			"testsTakenSubtitle_one": "อ้างอิงจากข้อสอบที่ทำไปแล้ว {{count}} ชุด",
			"testsTakenSubtitle_other": "อ้างอิงจากข้อสอบที่ทำไปแล้ว {{count}} ชุด",
			"startFirstTest": {
				"title": "มาเริ่มกันเลย",
				"itemsSubtitle_one": "{{count}} ข้อ",
				"itemsSubtitle_other": "{{count}} ข้อ",
				"guidance": {
					"diagnostic": "เริ่มด้วยแบบทดสอบวัดระดับเพื่อค้นหาจุดแข็งของคุณและปรับแผนการเรียนให้เหมาะสม",
					"sectional": "ข้อสอบแยกส่วนจะเน้นเพียงส่วนเดียวของการสอบ คุณจึงได้คะแนนโดยใช้เวลาทำน้อยลง",
					"fullMock": "ข้อสอบจำลองเต็มรูปแบบจำลองการสอบจริงตั้งแต่ต้นจนจบ และให้คะแนนที่สมบูรณ์ที่สุด"
				}
			},
			"noScoresTitle": "ยังไม่มีคะแนน{{skill, lowercase}}",
			"noScoresSubtitle": "ทำข้อสอบครั้งแรกเพื่อดูคะแนนโดยประมาณและรายละเอียดงานของคุณ",
			"noScoresCta": "เริ่ม",
			"noScoresCardSubtitle": "อ้างอิงจากข้อสอบที่คุณทำ",
			"personalBestLabel": "สถิติที่ดีที่สุดของคุณ",
			"latestLabel": "ผลล่าสุดของคุณ",
			"examCountdown_one": "อีก {{count}} วันจะถึงวันสอบของคุณ",
			"examCountdown_other": "อีก {{count}} วันจะถึงวันสอบของคุณ",
			"greeting": {
				"none": "มาเริ่มกันเลย {{firstName}}! 🚀",
				"low": "เริ่มต้นได้ดี {{firstName}} — ลุยต่อเลย! 💪",
				"medium": "ทำได้ดีมาก {{firstName}} รักษาไว้แบบนี้! 💪",
				"high": "ใกล้ถึงเป้าหมายแล้ว {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "มาเริ่มกันเลย! 🚀",
				"low": "เริ่มต้นได้ดี — ลุยต่อเลย! 💪",
				"medium": "ทำได้ดีมาก รักษาไว้แบบนี้! 💪",
				"high": "ใกล้ถึงเป้าหมายแล้ว! 🎯"
			},
			"stats": {
				"untilExam": "วันสอบ",
				"itemsAnswered": "ข้อที่ตอบแล้ว",
				"responsesAnswered": "คำตอบ"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "รหัสผ่านไม่ถูกต้อง",
		"incorrectPassword": "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
		"passwordPlaceholder": "กรอกรหัสผ่าน",
		"emailPlaceholder": "เช่น dave@gmail.com",
		"verify": {
			"openEmail": "เปิดอีเมลเพื่อดำเนินการต่อ",
			"signInCta": "กำลังยืนยันบัญชีของคุณ...",
			"signUpCta": "กำลังสร้างบัญชีของคุณ...",
			"contactSupport": "ไม่เห็นอีเมลใช่ไหม ลองตรวจสอบในกล่องจดหมายขยะ หรือ",
			"contactSupportLink": "ติดต่อเรา",
			"resendMagicLink": "ส่งลิงก์เข้าสู่ระบบอีกครั้ง",
			"resendMagicLinkIn": "ส่งลิงก์เข้าสู่ระบบอีกครั้งใน {{time}}",
			"signInBody": "อีกนิดเดียว! เรากำลังยืนยันข้อมูลของคุณเพื่อให้เข้าสู่ระบบแอป {{appName}} ได้อย่างปลอดภัย",
			"signUpBody": "ใกล้เสร็จแล้ว! เรากำลังยืนยันข้อมูลของคุณเพื่อสร้างบัญชีแอป {{appName}} ใหม่",
			"magicLinkEmail": "เราได้ส่งลิงก์เข้าสู่ระบบไปที่ **{{email}}** แล้ว\nคลิกลิงก์ในอีเมลเพื่อเข้าสู่ระบบอย่างปลอดภัย",
			"magicLinkEmailExpiry": "ลิงก์นี้จะหมดอายุใน 10 นาที",
			"confirmEmail": "ยืนยันอีเมลของคุณ",
			"redirectingToApp": "กำลังเปลี่ยนเส้นทางไปยังแอป {{appName}}...",
			"appNotOpen": "แอปไม่เปิดขึ้นใช่ไหม คลิกปุ่มด้านล่างเพื่อเปิดแอปที่เกี่ยวข้อง",
			"openApp": "เปิดแอป {{appName}}",
			"installAppPrompt": "หากไม่มีอะไรเกิดขึ้น กรุณาตรวจสอบว่าคุณได้ติดตั้งแอป {{appName}} บนอุปกรณ์ของคุณแล้ว",
			"verifyAccountTitle": "ยืนยันบัญชีของคุณ",
			"emailResent": "ส่งลิงก์เข้าสู่ระบบไปที่ {{email}} แล้ว\nกรุณาตรวจสอบกล่องจดหมายของคุณ รวมถึงกล่องจดหมายขยะ",
			"verificationLinkExpired": "ลิงก์ยืนยันหมดอายุแล้ว",
			"verificationLinkExpiredBody": "ลิงก์ยืนยันจะหมดอายุหลังจาก 10 นาที และใช้ได้เพียงครั้งเดียว \nคุณสามารถขอลิงก์ใหม่ได้โดยเข้าสู่ระบบอีกครั้ง",
			"accountSetupTimeoutTitle": "ไม่สามารถเข้าสู่ระบบให้เสร็จสิ้นได้",
			"accountSetupTimeoutBody": "การตั้งค่าบัญชีของคุณใช้เวลานานกว่าที่คาดไว้ กรุณาลองเข้าสู่ระบบอีกครั้ง หรือติดต่อฝ่ายสนับสนุนหากยังพบปัญหาอยู่",
			"loginAgain": "เข้าสู่ระบบอีกครั้ง",
			"contactSupportExpiredLink": "หากยังพบปัญหานี้อยู่ กรุณาแจ้งให้เราทราบ",
			"successTitle": "คุณเข้าสู่ระบบแล้วในอีกแท็บหนึ่ง",
			"successBody": "ปิดแท็บนี้ หรือดำเนินการต่อจากที่นี่",
			"successCtaLabel": "ดำเนินการต่อที่นี่",
			"needHelpLabel": "ต้องการความช่วยเหลือไหม",
			"contactSupportButton": "ติดต่อฝ่ายสนับสนุน"
		},
		"contactSupportDialog": {
			"title": "เข้าสู่ระบบไม่ได้ใช่ไหม",
			"body": "หากคุณเข้าสู่ระบบไม่ได้ กรุณาติดต่อฝ่ายบริการลูกค้าของเรา หรือลองใหม่อีกครั้ง",
			"cta": "ส่งอีเมลถึงเรา"
		},
		"emailInstruction": {
			"default": "หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบในโฟลเดอร์จดหมายขยะ สแปม และรายการที่เพิ่งลบ",
			"edu": "หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบในโฟลเดอร์จดหมายขยะ สแปม และรายการที่เพิ่งลบ หรือติดต่อผู้ดูแลระบบไอทีของคุณ"
		},
		"createSessionLoader": {
			"configuringSession": "กำลังตั้งค่าเซสชัน",
			"analyzingMastery": "กำลังวิเคราะห์ความเชี่ยวชาญ",
			"loadingContent": "กำลังโหลดเนื้อหา"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "เราควรเรียกคุณว่าอะไรดี",
				"description": "ชื่อผู้ใช้ของคุณจะปรากฏบนกระดานผู้นำสาธารณะ ส่วนชื่อจริงจะไม่ถูกเปิดเผย",
				"usernameLabel": "ชื่อผู้ใช้",
				"firstNameLabel": "ชื่อ",
				"lastNameLabel": "นามสกุล",
				"avatarLabel": "รูปประจำตัว",
				"avatarTooltip": "รูปประจำตัวจะถูกสร้างขึ้นโดยอัตโนมัติจากชื่อผู้ใช้ของคุณ",
				"profileSaveFailed": "เราไม่สามารถบันทึกโปรไฟล์ของคุณได้ กรุณาลองใหม่อีกครั้ง"
			},
			"testDate": {
				"cta": "ดำเนินการต่อ"
			},
			"examDate": {
				"daysAway": "เท่ากับว่าเรามีเวลา {{value}} วัน เราจะให้ความสำคัญกับจุดที่คุณอ่อนที่สุดเป็นอันดับแรกทันที"
			},
			"skills": {
				"chooseAll": "เลือกได้ทุกข้อที่ตรงกับคุณ"
			},
			"plan": {
				"recommended": "แนะนำ"
			},
			"toeicLevelOverview": {
				"title": "ทุกคนล้วนมีจุดเริ่มต้น",
				"description": "การฝึกฝนช่วยให้คุณสร้างความเชี่ยวชาญในระดับหนึ่งก่อนจะก้าวสู่ระดับถัดไปอย่างเป็นธรรมชาติ",
				"illustrationLabel": "การก้าวจากระดับพื้นฐาน (A1–A2) สู่ระดับกลาง (B1–B2) และระดับเชี่ยวชาญ (C1)",
				"levels": {
					"basic": {
						"name": "ระดับพื้นฐาน",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "ระดับกลาง",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "ระดับเชี่ยวชาญ",
						"band": "C1"
					}
				},
				"progression": {
					"title": "คุณจะพัฒนาไปอย่างไร",
					"practiceSessions": "ฝึกฝนด้วยเซสชันที่แนะนำ",
					"buildMastery": "สร้างความเชี่ยวชาญในระดับปัจจุบันของคุณ",
					"growToward": "พัฒนาต่อไปสู่ระดับเชี่ยวชาญ"
				},
				"levelDetails": {
					"title": "แต่ละระดับหมายถึงอะไร",
					"scoreRange": "{{band}} · คะแนน {{min}}–{{max}}",
					"basic": {
						"name": "ผู้ใช้ระดับพื้นฐาน",
						"summary": "ภาษาอังกฤษในที่ทำงานแบบง่าย ๆ",
						"examples": {
							"forms": "แบบฟอร์มและประกาศ",
							"instructions": "คำแนะนำการใช้งาน",
							"announcements": "ประกาศสั้น ๆ"
						}
					},
					"intermediate": {
						"name": "ผู้ใช้ระดับกลาง",
						"summary": "การสื่อสารในที่ทำงานประจำวัน",
						"examples": {
							"emails": "อีเมลและบทสนทนา",
							"customers": "การสื่อสารกับลูกค้า",
							"followUps": "การติดตามผลหลังการประชุม"
						}
					},
					"proficient": {
						"name": "ผู้ใช้ระดับเชี่ยวชาญ",
						"summary": "ภาษาอังกฤษเชิงวิชาชีพและขั้นสูง",
						"examples": {
							"reports": "รายงานและงานนำเสนอที่ซับซ้อน",
							"negotiations": "การเจรจาที่ต้องใช้ความละเอียดอ่อน",
							"highStakes": "สถานการณ์เชิงวิชาชีพที่มีความสำคัญสูง"
						}
					}
				},
				"disclaimer": "คะแนน TOEIC Link เป็นแนวทางที่อ้างอิงตามกรอบ CEFR ไม่ใช่เกณฑ์ตัดสินที่ตายตัว การอ่านและการฟังพัฒนาแยกจากกัน คุณจึงอาจอยู่คนละระดับในแต่ละทักษะ"
			},
			"review": {
				"diagnosticChoice": {
					"title": "แบบทดสอบวัดระดับ: {{title}}",
					"body": "{{count}} ข้อ เพื่อค้นหาจุดที่ควรเน้น",
					"duration": "{{minutes}} นาที"
				},
				"homeChoice": {
					"title": "ขอสำรวจด้วยตัวเอง",
					"body": "ยังไม่พร้อมเริ่ม ขอลองดูแอปก่อน"
				}
			}
		},
		"common": {
			"changeLater": "คุณสามารถเปลี่ยนแปลงได้ในภายหลัง"
		},
		"actions": {
			"previous": "ก่อนหน้า",
			"finish": "เสร็จสิ้น",
			"start": "เริ่ม",
			"continue": "ดำเนินการต่อ",
			"stepIndicator": "ขั้นตอนที่ {{step}} จาก {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "เกี่ยวกับคุณ"
		},
		"exam": {
			"title": "การสอบของคุณ"
		},
		"subscriptions": {
			"title": "ผลิตภัณฑ์",
			"redeem": {
				"title": "แลกรับสิทธิ์การซื้อ"
			},
			"extend": {
				"cta": "ขยายเวลา"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "ตั้งวันสอบเป้าหมายของคุณ",
			"description": "วันที่นี้ใช้เพื่อวางแผนตารางเรียนภายในแอปเท่านั้น และไม่มีผลต่อการสมัครสอบอย่างเป็นทางการของคุณ",
			"dismissCta": "ยังไม่ใช่ตอนนี้",
			"confirmCta": "ตั้งวันสอบ"
		}
	},
	"account": {
		"title": "การตั้งค่าบัญชี",
		"currentExam": "การสอบปัจจุบัน",
		"subscriptions": "ผลิตภัณฑ์",
		"examDate": "วันสอบ",
		"examDateUpdated": "ตั้งวันสอบเป็น {{date}} แล้ว",
		"selectDate": "เลือกวันที่",
		"appearance": "การแสดงผล",
		"features": "ฟีเจอร์",
		"audioPlaybackTest": "แสดงกล่องโต้ตอบทดสอบการเล่นเสียง",
		"theme": "ธีม",
		"selectTheme": "เลือกธีม",
		"themeOptions": {
			"system": "ตามระบบ",
			"light": "สว่าง",
			"dark": "มืด"
		},
		"accountInfo": "บัญชี",
		"username": "ชื่อผู้ใช้",
		"name": "ชื่อ",
		"nameNotSet": "ยังไม่ได้ตั้งค่า",
		"save": "บันทึก",
		"editUsername": {
			"title": "แก้ไขชื่อผู้ใช้"
		},
		"editName": {
			"title": "แก้ไขชื่อ"
		},
		"email": "อีเมล",
		"dev": "นักพัฒนา",
		"sandbox": "แซนด์บ็อกซ์",
		"redoOnboarding": "เริ่มการแนะนำการใช้งานใหม่",
		"about": "เกี่ยวกับ",
		"termsOfService": "ข้อกำหนดในการให้บริการ",
		"privacyPolicy": "นโยบายความเป็นส่วนตัว",
		"aiToolsTos": "ข้อกำหนดการใช้เครื่องมือ AI",
		"support": "ฝ่ายสนับสนุน",
		"supportEmailBody": "ผม/ดิฉันติดต่อมาเพราะต้องการความช่วยเหลือเกี่ยวกับ [  ]\n\n\n\nข้อมูลต่อไปนี้จะช่วยให้แก้ไขปัญหาได้เร็วขึ้น: \n\nชื่อผู้ใช้ที่ผูกกับบัญชี (ดูได้ในการตั้งค่าเมื่อเข้าสู่ระบบแอปแล้ว):\n{{username}}\n\nอีเมลที่ผูกกับคำสั่งซื้อ (ดูได้ในการตั้งค่าเมื่อเข้าสู่ระบบแอปแล้ว):\n{{email}}\n\nหมายเลขคำสั่งซื้อ (มักพบในอีเมลใบเสร็จที่ส่งมาหลังการซื้อ):\n\nเป็นไปได้หรือไม่ว่ามีการใช้ชื่อหรืออีเมลอื่นในตอนที่ซื้อจริง หากใช่ กรุณาระบุ:\n\nชื่อและนามสกุล:\n\nอีเมล:",
		"contactSupport": "ติดต่อฝ่ายสนับสนุน",
		"signOut": "ออกจากระบบ",
		"signOutConfirmation": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ",
		"deleteAccount": "ลบบัญชี",
		"platform": "แพลตฟอร์ม",
		"partnerships": "พันธมิตร",
		"validUntil": "หมดอายุวันที่ {{date}}",
		"extendValidity": "ขยายระยะเวลาการใช้งาน",
		"redeemPurchase": "แลกรับสิทธิ์การซื้อ",
		"redeemPurchaseNoneFound": "ไม่มีรายการซื้อที่แลกรับสิทธิ์ได้",
		"redeemPurchaseCheckFailed": "ไม่สามารถตรวจสอบรายการซื้อได้ กรุณาลองใหม่อีกครั้ง",
		"purchases": "การสั่งซื้อ",
		"frequentlyAskedQuestions": "คำถามที่พบบ่อย",
		"deleteFeedbackForm": {
			"placeholder": "ความคิดเห็น"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "ต้องการข้อมูลเพิ่มเติม",
		"proficiencyLevelPendingTooltip": "ตอบข้อสอบ{{label}}เพิ่มอีก เพื่อให้เราประเมินระดับของคุณได้",
		"on": "เมื่อ",
		"gotIt": "เข้าใจแล้ว",
		"goBack": "ย้อนกลับ",
		"topic": "หัวข้อ",
		"itemCount_one": "{{count, number}} ข้อ",
		"itemCount_other": "{{count, number}} ข้อ",
		"examCount_one": "{{count}} การสอบ",
		"examCount_other": "{{count}} การสอบ",
		"questionCount_one": "{{count}} คำถาม",
		"questionCount_other": "{{count}} คำถาม",
		"item_one": "ข้อ",
		"item_other": "ข้อ",
		"and": "และ",
		"this": "นี้",
		"of": "จาก",
		"knowMore": "ดูข้อมูลเพิ่มเติม",
		"proficiency": "ระดับความสามารถ",
		"didNotAnswer": "ข้อที่คุณยังไม่ได้ตอบ",
		"notAnswered": "ยังไม่ได้ตอบ",
		"attempted": "ที่ทำไปแล้ว",
		"attempt": "ครั้งที่ทำ",
		"activity": "กิจกรรม",
		"performance": "ผลงาน",
		"estimatedProficiency": "ระดับความสามารถโดยประมาณ",
		"details": "รายละเอียด",
		"keepPracticing": "ฝึกฝนต่อไปนะ!",
		"leaveFeedback": "ส่งความคิดเห็น",
		"copiedToClipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
		"eg": "เช่น",
		"set": "ชุด",
		"hint": "คำใบ้",
		"itemType": "ประเภทข้อสอบ",
		"minute": "นาที",
		"minutes": "{{count}} นาที",
		"hour": "ชั่วโมง",
		"hours": "{{count}} ชั่วโมง",
		"continue": "ดำเนินการต่อ",
		"unlock": "ปลดล็อก",
		"cancel": "ยกเลิก",
		"view": "ดู",
		"switch": "สลับ",
		"update": "อัปเดต",
		"ok": "ตกลง",
		"yes": "ใช่",
		"free": "ฟรี",
		"answered": "ตอบแล้ว",
		"correct": "ถูกต้อง",
		"incorrect": "ไม่ถูกต้อง",
		"marked": "ทำเครื่องหมายแล้ว",
		"unmarked": "ยังไม่ได้ทำเครื่องหมาย",
		"skipped": "ข้ามแล้ว",
		"skill_one": "ทักษะ",
		"skill_other": "ทักษะ",
		"word_one": "คำ",
		"word_other": "คำ",
		"submitResponse": "ส่งคำตอบ",
		"viewDetails": "ดูรายละเอียด",
		"sec_one": "วินาที",
		"sec_other": "วินาที",
		"point_one": "คะแนน",
		"point_other": "คะแนน",
		"week": "สัปดาห์",
		"month": "เดือน",
		"year": "ปี",
		"day": "วัน",
		"selectTestDate": "เลือกวันสอบ",
		"points": "คะแนน",
		"viewAll": "ดูทั้งหมด",
		"timeline": "ไทม์ไลน์",
		"save": "บันทึก",
		"filters": {
			"selectAll": "เลือกทั้งหมด",
			"deselectAll": "ยกเลิกการเลือกทั้งหมด",
			"selectedCount": "เลือกแล้ว {{count}} รายการ",
			"expandSection": "ขยาย{{section}}",
			"collapseSection": "ย่อ{{section}}"
		},
		"showMore": "แสดงเพิ่มเติม",
		"showLess": "แสดงน้อยลง",
		"expandA11yLabel": "ขยายคำอธิบาย",
		"collapseA11yLabel": "ย่อคำอธิบาย",
		"done": "เสร็จสิ้น",
		"clearAll": "ล้างทั้งหมด",
		"clear": "ล้าง",
		"datePicker": {
			"title": "เลือกวันที่",
			"enterDateLabel": "กรอกวันที่",
			"enterDateRangeLabel": "กรอกช่วงวันที่",
			"dateLabel": "วันที่",
			"startDateLabel": "วันที่เริ่มต้น",
			"endDateLabel": "วันที่สิ้นสุด",
			"dateRequiredError": "กรุณาระบุวันที่",
			"invalidDateFormatError": "รูปแบบวันที่ไม่ถูกต้อง กรุณาใช้ MM/DD/YYYY",
			"startAfterEndError": "วันที่เริ่มต้นต้องไม่อยู่หลังวันที่สิ้นสุด",
			"endBeforeStartError": "วันที่สิ้นสุดต้องไม่อยู่ก่อนวันที่เริ่มต้น",
			"minDateError": "วันที่ต้องเป็น {{date}} หรือหลังจากนั้น",
			"maxDateError": "วันที่ต้องเป็น {{date}} หรือก่อนหน้านั้น",
			"dateRangeError": "วันที่ต้องอยู่ระหว่าง {{startDate}} ถึง {{endDate}}",
			"setDateCta": "ตั้งวันที่",
			"nextCta": "ถัดไป",
			"setTimeCta": "ตั้งเวลา"
		}
	},
	"session": {
		"choicePercentageTooltip": "ผู้เรียน {{percentage}} เลือกคำตอบนี้",
		"choiceCorrectA11yLabel": "คำตอบที่ถูกต้อง",
		"choiceIncorrectA11yLabel": "คำตอบที่ผิด",
		"choiceNotSelectedA11yLabel": "ไม่ได้เลือก",
		"moreItemsAlertDialog": {
			"title": "ข้อสอบเพิ่มเติม",
			"cta": "เข้าใจแล้ว"
		},
		"results": {
			"followUps": {
				"title": "คำถามต่อเนื่อง"
			},
			"summary": {
				"sessionAnalysis": "การวิเคราะห์เซสชัน",
				"itemCount_one": "{{count}} ข้อ",
				"itemCount_other": "{{count}} ข้อ",
				"skilledItemCount_one": "ข้อสอบ{{skills}} {{count}} ข้อ",
				"skilledItemCount_other": "ข้อสอบ{{skills}} {{count}} ข้อ",
				"levelPhrase_one": "ในระดับ {{levels}}",
				"levelPhrase_other": "ในระดับ {{levels}}",
				"message": "<bold>ทำได้ดีมาก!</bold> คุณเพิ่งทำ{{itemPhrase}}เสร็จภายใน {{timeTaken}}",
				"messageWithLevels": "<bold>ทำได้ดีมาก!</bold> คุณเพิ่งทำ{{itemPhrase}}$t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"})เสร็จภายใน {{timeTaken}}",
				"proficiencyEstimateReady": "ระดับ{{skill}}โดยประมาณของคุณคือ <bold>{{currentLevel}}</bold> ตอนนี้คุณพร้อมที่จะมุ่งสู่ระดับ <bold>{{nextLevel}}</bold> แล้ว",
				"proficiencyEstimateKeepPracticing": "ระดับ{{skill}}โดยประมาณของคุณคือ <bold>{{currentLevel}}</bold> ฝึกฝนเพิ่มอีกสักหน่อยก่อนก้าวสู่ระดับ <bold>{{nextLevel}}</bold>",
				"proficiencyEstimateHighest": "ระดับ{{skill}}โดยประมาณของคุณคือ <bold>{{currentLevel}}</bold> ยอดเยี่ยมมาก!",
				"mixedLevel": "ผสม",
				"overallScore": "คะแนนรวม",
				"stats": {
					"itemsAttempted_one": "ข้อที่ตอบแล้ว",
					"itemsAttempted_other": "ข้อที่ตอบแล้ว",
					"pointsEarned_one": "คะแนนที่ได้รับ",
					"pointsEarned_other": "คะแนนที่ได้รับ",
					"answeredCorrectly": "ตอบถูกต้อง",
					"timeTaken": "เวลาที่ใช้",
					"target": "เป้าหมาย",
					"ofTotal": "จาก {{total}}",
					"ofPointsTotal": "จาก {{total}}",
					"skill": "ทักษะ",
					"skills": "ทักษะ",
					"questionType": "ประเภทคำถาม",
					"questionTypes": "ประเภทคำถาม",
					"proficiencyLevel": "ระดับความสามารถ",
					"proficiencyLevels": "ระดับความสามารถ"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "เสียงจะเริ่มเล่นในอีก {{seconds}} วินาที",
			"audioStartsInPlayOnce": "เสียงจะเริ่มเล่นในอีก {{seconds}} วินาที และเล่นเพียงครั้งเดียว",
			"videoStartsIn": "วิดีโอจะเริ่มเล่นในอีก {{seconds}} วินาที",
			"videoStartsInPlayOnce": "วิดีโอจะเริ่มเล่นในอีก {{seconds}} วินาที และเล่นเพียงครั้งเดียว",
			"recordingIn": "จะเริ่มบันทึกเสียงในอีก {{seconds}} วินาที"
		},
		"timeOverrunBanner": {
			"message": "หมดเวลาแล้ว ในการสอบจริง สิ่งที่ทำหลังจากนี้จะไม่ถูกนำมาคิดคะแนน แต่คุณยังฝึกฝนต่อได้"
		},
		"attributes": {
			"stimulus": "สื่อประกอบคำถาม"
		},
		"stimulusTypes": {
			"reading": "การอ่าน",
			"listening": "การฟัง",
			"speaking": "การพูด",
			"writing": "การเขียน",
			"image": "รูปภาพ"
		},
		"masteryLevels": {
			"belowBasic": "ต่ำกว่าระดับพื้นฐาน",
			"basic": "ระดับพื้นฐาน",
			"belowLowIntermediate": "ต่ำกว่าระดับกลางตอนต้น",
			"lowIntermediate": "ระดับกลางตอนต้น",
			"highIntermediate": "ระดับกลางตอนปลาย",
			"advanced": "ระดับสูง",
			"proficiencySubtitle": "ใน {{trademark}} ระดับนี้เทียบเท่าคะแนน **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "ข้อมูลส่วน{{skill}}",
			"infoSectionText": {
				"Reading": "ส่วนการอ่านของ {{trademark}} ประเมินว่าคุณอ่านและทำความเข้าใจเอกสารที่ใช้ในสภาพแวดล้อมทางวิชาการได้ดีเพียงใด ประกอบด้วยบทอ่าน 2 บท ความยาวประมาณ 700 คำต่อบท และมีคำถามบทละ 10 ข้อ ใช้เวลาทำส่วนการอ่านประมาณ 35 นาที",
				"Listening": "ส่วนการฟังของ {{trademark}} ออกแบบมาเพื่อวัดความสามารถในการเข้าใจบทสนทนาและการบรรยายภาษาอังกฤษ ครอบคลุมการฟังเพื่อจับใจความพื้นฐาน การเข้าใจทัศนคติและระดับความมั่นใจของผู้พูด และการเชื่อมโยงข้อมูล ใช้เวลาทำส่วนการฟังประมาณ 36 นาที",
				"Speaking": "ส่วนการพูดของ {{trademark}} วัดความสามารถในการพูดภาษาอังกฤษได้อย่างมีประสิทธิภาพในบริบททางวิชาการ คำถาม/ภารกิจทั้งสี่ข้อจำลองสถานการณ์จริงที่คุณอาจพบทั้งในและนอกห้องเรียน ใช้เวลาทำส่วนการพูดประมาณ 16 นาที",
				"Writing": "ส่วนการเขียนของ {{trademark}} วัดความสามารถในการเขียนภาษาอังกฤษในบริบททางวิชาการ และการนำเสนอความคิดอย่างชัดเจนและเป็นระบบ คุณจะพิมพ์คำตอบด้วยแป้นพิมพ์คอมพิวเตอร์ และใช้เวลาทำส่วนการเขียนประมาณ 29 นาที"
			}
		},
		"itemTypes": {
			"MCSS": "ปรนัยเลือกคำตอบเดียว",
			"MCSSH": "ปรนัยเลือกคำตอบเดียวแบบไฮไลต์",
			"MCMS": "ปรนัยเลือกหลายคำตอบ",
			"MCMSH": "ปรนัยเลือกหลายคำตอบแบบไฮไลต์",
			"INSERT_TEXT": "แทรกข้อความ",
			"MATCH_MS": "จับคู่แบบเลือกหลายคำตอบ",
			"MCSSM": "ปรนัยเลือกคำตอบเดียวแบบจับคู่",
			"MCMSM": "ปรนัยเลือกหลายคำตอบแบบจับคู่",
			"MCGS": "ปรนัยเติมช่องว่าง",
			"MCOS": "ปรนัยเรียงลำดับ",
			"LISTENING_REPLAY": "เล่นเสียงซ้ำ",
			"AUDIO_INPUT": "ตอบด้วยเสียง",
			"ACADEMIC_DISCUSSION_RESPONSE": "การตอบอภิปรายเชิงวิชาการ",
			"INTEGRATED_WRITING_RESPONSE": "การเขียนแบบบูรณาการ"
		},
		"passageStem": {
			"itemOfTotal": "ข้อ {{current}} จาก {{total}}",
			"questionOfTotal": "คำถามข้อ {{current}} จาก {{total}}",
			"stimulusCorrespondsToNextItems": "สื่อประกอบต่อไปนี้ใช้กับข้อสอบ {{total}} ข้อถัดไป",
			"passage": "บทอ่าน",
			"lecture": "การบรรยาย",
			"professorsQuestion": "คำถามของอาจารย์",
			"listen": "ฟัง",
			"openPassage": "เปิดบทอ่าน",
			"backToItem": "กลับไปที่ข้อสอบ",
			"notYetInserted": "ยังไม่ได้แทรก",
			"insertedAtPosition": "แทรกไว้ที่ตำแหน่ง #{{position}}"
		},
		"hint": {
			"show": "แสดงคำใบ้"
		},
		"navigation": {
			"next": "ถัดไป",
			"exit": "ออก",
			"saveAndExit": "บันทึกและออก",
			"previous": "ก่อนหน้า",
			"skip": "ข้าม",
			"finish": "เสร็จสิ้น",
			"help": "ความช่วยเหลือ",
			"about": "เคล็ดลับคำถาม",
			"questionsButtonLabel": "การนำทางคำถาม",
			"questionsButtonTooltip": "ข้ามไปยังคำถามใดก็ได้ หรือทบทวนข้อที่ทำเครื่องหมายไว้",
			"questionsButtonActiveFiltersA11y": "ตัวกรองที่ใช้อยู่: {{count}}",
			"recordingInProgressTooltip": "คุณไม่สามารถออกจากข้อนี้ได้ขณะกำลังบันทึกเสียง",
			"questionNotReachedTooltip": "คุณยังมาไม่ถึงคำถามข้อนี้"
		},
		"questionTips": {
			"hideFutureLabel": "ไม่ต้องแสดงเคล็ดลับอัตโนมัติ"
		},
		"toolbar": {
			"calculatorTooltip": "เปิดเครื่องคิดเลข",
			"highlightTooltip": "เลือกข้อความเพื่อไฮไลต์ข้อมูลสำคัญไว้ดูภายหลังได้สะดวก",
			"markTooltip": "ทำเครื่องหมายคำถามนี้เพื่อกลับมาดูอีกครั้งก่อนส่งคำตอบ",
			"unmarkTooltip": "คลิกเพื่อยกเลิกการทำเครื่องหมายคำถามนี้"
		},
		"summary": {
			"viewFullInsights": "ดูข้อมูลเชิงลึกทั้งหมด",
			"targetTooltip": "เป้าหมายผลงานสำหรับเซสชันนี้"
		},
		"stats": {
			"skill": "ทักษะ",
			"answered": "ตอบแล้ว",
			"speed": "ความเร็ว",
			"duration": "ความยาว",
			"duration_tooltip": "ความยาวของคำตอบที่คุณบันทึกไว้: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "ความมั่นใจ",
			"pointsEarned": "คะแนน",
			"word": "คำ",
			"words": "คำ",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "คุณใช้เวลา {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) ในการอ่านและตอบข้อนี้",
			"skill_tooltip": "ทักษะที่ประเมินในข้อนี้: {{skill}}",
			"answered_correct_tooltip": "คำตอบที่คุณส่งถูกต้อง",
			"answered_incorrect_tooltip": "คำตอบที่คุณส่งไม่ถูกต้อง",
			"skipped_tooltip": "คุณไม่ได้ส่งคำตอบสำหรับข้อนี้",
			"words_tooltip": "จำนวนคำในคำตอบที่คุณเขียน: {{count}}",
			"word_tooltip": "จำนวนคำในคำตอบที่คุณเขียน: {{count}}",
			"confidence_tooltip": "ระดับความมั่นใจของคุณตอนที่ส่งคำตอบ",
			"points_earned_tooltip_one": "คุณได้รับ {{points}} คะแนน จากคะแนนเต็ม {{maximumScore}} คะแนนสำหรับข้อนี้",
			"points_earned_tooltip_other": "คุณได้รับ {{points}} คะแนน จากคะแนนเต็ม {{maximumScore}} คะแนนสำหรับข้อนี้",
			"challengers_tooltip": "จำนวนผู้เรียนที่ตอบข้อนี้ก่อนคุณ: {{count}}",
			"learning_mode_points_tooltip": "คะแนนที่ได้รับจากการทำครั้งนี้: +{{xp}} XP",
			"pts_earned_tooltip": "คะแนนที่ได้รับจากการทำครั้งนี้: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "ขยายรายละเอียด"
		},
		"explanation": {
			"title": "คำอธิบาย",
			"feedback": "ผลตอบกลับ",
			"skippedFeedbackNotice": "คุณข้ามคำถามข้อนี้ จึงไม่มีการสร้างผลตอบกลับเฉพาะบุคคล"
		},
		"followUps": "คำถามต่อเนื่อง",
		"suggestCorrection": "เสนอการแก้ไข",
		"answer": {
			"correct": "ถูกต้อง",
			"incorrect": "ไม่ถูกต้อง",
			"skipped": "ข้ามแล้ว"
		},
		"confidence": {
			"high": "สูง",
			"medium": "ปานกลาง",
			"low": "ต่ำ"
		},
		"endDialog": {
			"title": "จบเซสชันก่อนกำหนดไหม",
			"confirmEndDiagnostic": "คุณแน่ใจหรือไม่ว่าต้องการจบเซสชันนี้ ความคืบหน้าทั้งหมดจะหายไปและคุณต้องเริ่มใหม่ตั้งแต่ต้น",
			"confirmEnd": "คุณยังเหลืออีก {{num}} {{itemLabel}} คุณจะจบตอนนี้ หรือเรียนต่อให้ครบก็ได้",
			"confirmEndNoAnswer": "คุณยังไม่ได้ตอบคำถามใดเลย แน่ใจหรือไม่ว่าต้องการจบตอนนี้",
			"confirmEndNoAnswerPositive": "เรียนต่อ",
			"confirmEndNoAnswerNegative": "จบตอนนี้"
		},
		"permissionDialog": {
			"title": "ต้องอนุญาตให้เข้าถึงไมโครโฟน",
			"descriptionWeb": "การฝึกพูดต้องใช้ไมโครโฟนของคุณ เบราว์เซอร์กำลังบล็อกการเข้าถึงสำหรับเว็บไซต์นี้ — คลิกไอคอนการอนุญาตข้างช่องที่อยู่เว็บ อนุญาตไมโครโฟน แล้วลองใหม่อีกครั้ง",
			"descriptionMobile": "การฝึกพูดต้องใช้ไมโครโฟนของคุณ กรุณาอนุญาตการเข้าถึงไมโครโฟนในการตั้งค่าอุปกรณ์เพื่อดำเนินการต่อ",
			"promptDescriptionWeb": "การฝึกพูดต้องใช้ไมโครโฟนของคุณ กรุณาขออนุญาตแล้วเลือก \"อนุญาต\" เมื่อเบราว์เซอร์ถาม",
			"blockedDescriptionWeb": "การเข้าถึงไมโครโฟนสำหรับเว็บไซต์นี้ถูกบล็อกอยู่ คลิกไอคอนข้างช่องที่อยู่เว็บ อนุญาตไมโครโฟน แล้วขออนุญาตอีกครั้ง",
			"ok": "ตกลง",
			"cancel": "ยกเลิก",
			"openSettings": "เปิดการตั้งค่า",
			"requestPermission": "ขออนุญาต",
			"dismissAndExit": "ปิดและออก",
			"learnMore": "ดูข้อมูลเพิ่มเติม"
		},
		"audioPlaybackTestDialog": {
			"title": "ทดสอบการเล่นเสียง",
			"description": "แอป {{appName}} มีฟีเจอร์การเล่นเสียงหลายอย่าง เช่น เสียงในสื่อประกอบคำถาม ข้อสอบ และการอ่านออกเสียงข้อความ เพื่อประสบการณ์ที่ดีที่สุด กรุณาทดสอบเสียงของคุณด้านล่าง เมื่อยืนยันว่าใช้งานได้แล้วจึงดำเนินการต่อ",
			"troubleshooting": {
				"title": "การแก้ปัญหาเรื่องเสียง",
				"volumeTitle": "ตรวจสอบระดับเสียงของอุปกรณ์",
				"volumeDescriptionWeb": "ปรับระดับเสียงด้วยปุ่มบนแป้นพิมพ์ หรือการตั้งค่าเสียงของระบบในแถบเมนู/แถบงาน",
				"volumeDescriptionMobile": "ใช้ปุ่มปรับระดับเสียงของอุปกรณ์ หรือปรับในการตั้งค่าระบบ",
				"outputTitle": "ตรวจสอบอุปกรณ์ส่งออกเสียง",
				"outputDescription": "หากใช้หูฟัง กรุณาตรวจสอบว่าเชื่อมต่ออย่างถูกต้องและถูกเลือกเป็นอุปกรณ์ส่งออกเสียงที่ใช้งานอยู่",
				"browserTitle": "ตรวจสอบเสียงของแท็บเบราว์เซอร์",
				"browserDescription": "มองหาไอคอนลำโพงปิดเสียงข้างชื่อแท็บ และเปิดเสียงหากพบไอคอนดังกล่าว"
			},
			"skipCheck": "ข้ามการตรวจสอบนี้ในครั้งถัดไป",
			"workingButton": "ยืนยันว่าเสียงใช้งานได้",
			"textToHear": "คุณควรได้ยิน: {{text}}"
		},
		"overall": "โดยรวม",
		"subskills": {
			"content": {
				"title": "เนื้อหา"
			},
			"languageUse": {
				"title": "การใช้ภาษา"
			},
			"organizationAndDevelopment": {
				"title": "การจัดลำดับและการขยายความ"
			},
			"topicDevelopment": {
				"title": "การพัฒนาหัวข้อ"
			},
			"delivery": {
				"title": "การถ่ายทอด"
			}
		},
		"finalizing": {
			"title": "กำลังสรุปผลลัพธ์ของคุณ",
			"gradingProgress": "กำลังตรวจให้คะแนนคำตอบ..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "แบบฝึกการพูดที่ผู้เรียนพูดซ้ำประโยคที่ได้ยินให้ถูกต้องที่สุด",
			"Read Aloud": "ข้อสอบการพูดที่ผู้เรียนอ่านออกเสียงข้อความเพื่อรับการประเมิน",
			"Describe Image": "แบบฝึกการพูดที่ผู้เรียนบรรยายภาพอย่างละเอียด",
			"Write Essay": "แบบฝึกเขียนตอบที่ต้องเขียนเรียงความอย่างมีโครงสร้างตามหัวข้อที่กำหนด",
			"Retell Lecture": "แบบฝึกการพูดที่ผู้เรียนสรุปการบรรยายหรือการพูดที่ได้ฟัง",
			"Summarize Group Discussion": "แบบฝึกการฟังที่ผู้เรียนสรุปการสนทนาที่มีผู้พูดหลายคน",
			"Answer Short Question": "แบบฝึกการพูดสั้น ๆ ที่ตอบคำถามสั้นหนึ่งข้อด้วยคำตอบกระชับ",
			"Respond to a Situation": "แบบฝึกการพูดที่ผู้เรียนตอบสนองอย่างเหมาะสมต่อสถานการณ์ที่กำหนด",
			"Summarize Written Text": "แบบฝึกการอ่านที่ผู้เรียนสรุปข้อความด้วยคำพูดของตนเอง",
			"Reorder Paragraph": "แบบฝึกการอ่านที่ผู้เรียนเรียงย่อหน้าที่สลับกันให้ถูกต้อง",
			"Fill in the Blanks (Dropdown)": "แบบฝึกการอ่านที่เติมแต่ละช่องว่างโดยเลือกจากรายการตัวเลือก",
			"Fill in the Blanks (Type In)": "แบบฝึกการฟังที่ผู้เรียนพิมพ์คำหรือวลีสั้น ๆ ที่หายไป",
			"Fill in the Blanks (Drag and Drop)": "แบบฝึกการอ่านที่เติมคำที่หายไปโดยลากตัวเลือกไปยังช่องว่าง",
			"Multiple Choice, Single Answer": "ข้อสอบปรนัยที่ผู้เรียนเลือกคำตอบที่ถูกต้องหนึ่งข้อ",
			"Multiple Choice, Single Answer (Reading)": "ข้อสอบปรนัยการอ่านที่ผู้เรียนเลือกคำตอบที่ถูกต้องหนึ่งข้อ",
			"Multiple Choice, Single Answer (Listening)": "ข้อสอบปรนัยการฟังที่ผู้เรียนเลือกคำตอบที่ถูกต้องหนึ่งข้อ",
			"Multiple Choice, Multiple Answers": "ข้อสอบที่ผู้เรียนสามารถเลือกคำตอบที่ถูกต้องได้มากกว่าหนึ่งข้อ",
			"Multiple Choice, Multiple Answers (Reading)": "ข้อสอบการอ่านที่ผู้เรียนสามารถเลือกคำตอบที่ถูกต้องได้มากกว่าหนึ่งข้อ",
			"Multiple Choice, Multiple Answers (Listening)": "ข้อสอบการฟังที่ผู้เรียนสามารถเลือกคำตอบที่ถูกต้องได้มากกว่าหนึ่งข้อ",
			"Summarize Spoken Text": "แบบฝึกการฟังที่ผู้เรียนเขียนสรุปสิ่งที่ได้ฟัง",
			"Highlight Correct Summary": "แบบฝึกการฟังที่ผู้เรียนไฮไลต์บทสรุปที่ตรงกับเสียงมากที่สุด",
			"Select Missing Word": "แบบฝึกการฟังแบบเติมคำที่ผู้เรียนเลือกคำที่หายไป",
			"Highlight Incorrect Words": "แบบฝึกการฟังที่ผู้เรียนไฮไลต์คำในบทถอดเสียงที่ต่างจากเสียงที่ได้ยิน",
			"Write from Dictation": "แบบฝึกการฟังที่ผู้เรียนเขียนตามประโยคที่ได้ยิน"
		}
	},
	"report": {
		"readFullInsights": "ดูข้อมูลเชิงลึกทั้งหมด",
		"productName": "{{examName}} {{type}}",
		"startedAt": "เริ่มเมื่อ {{time}}",
		"itemTypesTitle": "รายละเอียดตามประเภทข้อสอบ",
		"itemTypesFilterAll": "ทั้งหมด",
		"questionTypeCardTitle": "รายละเอียดประเภทข้อสอบ{{skill}}",
		"questionTypeCardSubtitle_one": "อ้างอิงจากประเภทข้อสอบ{{skill}} {{count}} ประเภทในเซสชันนี้",
		"questionTypeCardSubtitle_other": "อ้างอิงจากประเภทข้อสอบ{{skill}} {{count}} ประเภทในเซสชันนี้",
		"questionTypeCardAltSubtitle_one": "อ้างอิงจากประเภทข้อสอบ {{count}} ประเภทในเซสชันนี้",
		"questionTypeCardAltSubtitle_other": "อ้างอิงจากประเภทข้อสอบ {{count}} ประเภทในเซสชันนี้",
		"questionTypeRowSubtitle_zero": "ยังไม่ได้ตอบข้อใด",
		"questionTypeRowSubtitle_one": "ตอบแล้ว {{count}} ข้อ",
		"questionTypeRowSubtitle_other": "ตอบแล้ว {{count}} ข้อ",
		"itemTypeDetail": {
			"review_one": "ทบทวนข้อสอบ",
			"review_other": "ทบทวนข้อสอบ",
			"stats": {
				"answered_one": "ข้อที่ตอบแล้ว",
				"answered_other": "ข้อที่ตอบแล้ว",
				"avgTime": "เวลาเฉลี่ยต่อข้อ"
			}
		},
		"reviewAnswersDialog": {
			"title": "ทบทวนคำตอบ",
			"sections": {
				"skills": "ทักษะ",
				"questionTypes": "ประเภทคำถาม",
				"proficiency": "ระดับความสามารถ",
				"performance": "ผลงาน"
			},
			"summaryNone": "เลือกตัวกรองที่มีข้อสอบเพื่อดำเนินการต่อ",
			"summaryAll_one": "ทบทวนคำตอบทั้งหมด {{count}} ข้อ",
			"summaryAll_other": "ทบทวนคำตอบทั้งหมด {{count}} ข้อ",
			"summaryFiltered_one": "ทบทวน {{count}} คำตอบที่ตรงกับ {{filters}}",
			"summaryFiltered_other": "ทบทวน {{count}} คำตอบที่ตรงกับ {{filters}}",
			"reviewAnswers_one": "ทบทวน {{count}} คำตอบ",
			"reviewAnswers_other": "ทบทวน {{count}} คำตอบ",
			"more": "อีก {{count}} รายการ"
		},
		"itemDetail": {
			"title": "ทบทวนคำตอบของฉัน",
			"filterAll": "ทั้งหมด",
			"filterCorrect": "ถูกต้อง",
			"filterIncorrect": "ไม่ถูกต้อง",
			"filterMarked": "ทำเครื่องหมายแล้ว",
			"emptyTitle": "ไม่พบข้อสอบที่ตรงกัน",
			"emptyDescription": "ไม่มีข้อสอบในเซสชันของคุณที่ตรงกับตัวกรองที่เลือก ({{filter}}) ลองปรับหรือล้างตัวกรองเพื่อดูผลลัพธ์เพิ่มเติม",
			"emptyCta": "ล้างตัวกรอง"
		},
		"answerCardTitle": "ข้อที่ตอบแล้ว",
		"answerCardSubtitle_one": "ดูว่าคุณทำได้ดีแค่ไหนในทุกคำถาม",
		"answerCardSubtitle_other": "ดูว่าคุณทำได้ดีแค่ไหนในทั้ง {{count}} คำถาม",
		"skillsBreakdown": {
			"title": "รายละเอียดตามทักษะ",
			"subtitle_one": "อ้างอิงจาก {{count}} ข้อ",
			"subtitle_other": "อ้างอิงจาก {{count}} ข้อ"
		},
		"studyPack": "ชุดการเรียน",
		"practiceTestCompleted": "ทำข้อสอบเสมือนจริงเสร็จแล้ว",
		"studySessionCompleted": "เซสชันการเรียนเสร็จสิ้นแล้ว",
		"diagnosticSessionCompleted": "แบบทดสอบวัดระดับเสร็จสิ้นแล้ว",
		"timeElapsed": "เวลาที่ผ่านไป",
		"stats": {
			"answered": "ตอบแล้ว",
			"time elapsed": "เวลาที่ผ่านไป",
			"avg speed": "ความเร็วเฉลี่ย",
			"hints used": "คำใบ้ที่ใช้"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "ยอดเยี่ยมมาก มุ่งสู่ความเป็นเลิศต่อไป!",
				"highIntermediate": "คุณทำได้ดีมาก ฝึกฝนจุดแข็งของคุณต่อไป!",
				"lowIntermediate": "คุณพัฒนาขึ้นอย่างสม่ำเสมอ รักษาไว้แบบนี้!",
				"basic": "พยายามต่อไปเพื่อยกระดับความสามารถของคุณ!"
			},
			"infoText": "คุณทำ **{{numActivities}} {{activityLabel}}** เสร็จแล้ว เพื่อฝึก{{skillsText}}{{skills}}ของคุณ {{skillDetails}} โดยรวมคุณได้ **{{numPointsEarned}} จาก {{numTotalPoints}} คะแนน** ซึ่งบ่งชี้ถึง**ระดับความสามารถ {{compositeLevel}}** ใน{{thisText}}{{skills}} {{compositeFeedback}}",
			"infoText.singleSkill": "คุณทำ **{{itemCount}} {{itemLabel}}** เสร็จแล้ว โดยเน้นทักษะ **{{skill_1}}** ของคุณ คุณได้ **{{skill_1_score}} จาก {{skill_1_total}} คะแนน** ซึ่งบ่งชี้ถึงระดับความสามารถ **{{proficiency}}** {{compositeFeedback}}",
			"infoText.multiSkill": "คุณทำ **{{itemCount}} {{itemLabel}}** เสร็จแล้ว โดยฝึกทักษะ **{{skills_text}}** ของคุณ {{skill_details}} โดยรวมคุณได้ **{{overall_score}} จาก {{overall_total}} คะแนน** ซึ่งบ่งชี้ถึงระดับความสามารถ **{{overall_proficiency}}** ในทักษะเหล่านี้ {{compositeFeedback}}",
			"skillDetails": "ในทักษะ **{{skill}}** คุณได้ **{{score}} จาก {{total}} คะแนน** ซึ่งแสดงถึงระดับความสามารถ **{{proficiency}}**"
		},
		"actions": {
			"goToHome": "ไปที่หน้าแรก",
			"studyMore": "เรียนเพิ่มเติม",
			"studyFree": "เรียน{{tagTypes}}ฟรี",
			"reviewAnswers": "ทบทวนคำตอบ"
		},
		"nextAction": {
			"title": "แนะนำ: ฝึก{{focus}}",
			"dialog": {
				"title": "เซสชันการเรียนที่แนะนำ",
				"subtitle": "เน้นจุดที่คุณยังขาด"
			},
			"fallback": {
				"title": "ฝึกฝนต่อไป",
				"description": "สร้างเซสชันการเรียนรอบ ๆ จุดที่คุณอยากพัฒนาต่อไป"
			}
		},
		"premium": {
			"upgradeCta": "อัปเกรดเป็นพรีเมียม"
		},
		"disclaimer": {
			"title": "ข้อจำกัดความรับผิดชอบ",
			"summativeBody": "คะแนนข้อสอบเสมือนจริงเป็นเพียงการประมาณการ และไม่รับประกันว่าจะได้ผลลัพธ์เดียวกันในการสอบ {{examName}} จริง"
		},
		"performance": {
			"title": "ผลงาน",
			"subtitle": "อ้างอิงจาก {{count}} ข้อ",
			"correct": "ถูกต้อง",
			"correctItems": "{{count}} ข้อ",
			"incorrect": "ไม่ถูกต้อง",
			"incorrectItems": "{{count}} ข้อ"
		},
		"mastery": {
			"performanceTitle": "ผลงาน",
			"sessionMasteryTitle": "ระดับความสามารถโดยประมาณ",
			"subtitle_assessment": "อ้างอิงจากทั้งหมด {{count}} {{item}} ของแบบประเมินนี้",
			"subtitle_session": "อ้างอิงจากทั้งหมด {{count}} {{item}} ของเซสชันนี้"
		},
		"sessionAnalysis": {
			"title": "การวิเคราะห์เซสชัน",
			"subtitle": "การวิเคราะห์และคำแนะนำเฉพาะบุคคล",
			"viewFullAnalysis": "ดูการวิเคราะห์",
			"feedbackDialog": {
				"body": "เราออกอัปเดตเกือบทุกวันและมุ่งมั่นที่จะพัฒนาให้ดียิ่งขึ้น ขอความคิดเห็นจากคุณได้ไหม",
				"placeholder": "กรอกความคิดเห็นของคุณที่นี่",
				"cta": "ส่งความคิดเห็น",
				"successMessage": "ส่งความคิดเห็นเรียบร้อยแล้ว ขอบคุณ!",
				"feedbackLimitError": "ความคิดเห็นต้องมีความยาวอย่างน้อย 10 ตัวอักษร"
			},
			"menuActions": {
				"copy": "คัดลอก",
				"altCopy": "คัดลอกข้อความสรุป",
				"altPositiveFeedback": "ข้อมูลนี้มีประโยชน์",
				"positiveFeedback": "คำตอบดี",
				"negativeFeedback": "คำตอบไม่ดี",
				"reportIssue": "รายงาน",
				"altReportIssue": "รายงานคำตอบนี้",
				"emailSummary": "ส่งข้อความสรุปทางอีเมล",
				"emailAlreadySent": "ส่งอีเมลไปแล้ว",
				"copiedAnalysis": "คัดลอกการวิเคราะห์ไปยังคลิปบอร์ดแล้ว",
				"emailSent": "ส่งอีเมลไปที่ {{email}} แล้ว หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบในโฟลเดอร์จดหมายขยะ สแปม และรายการที่เพิ่งลบ",
				"emailFailed": "ส่งอีเมลไปที่ {{email}} ไม่สำเร็จ",
				"emailInstructionMessage": "หากคุณไม่ได้รับอีเมล กรุณาตรวจสอบในโฟลเดอร์จดหมายขยะ สแปม และรายการที่เพิ่งลบ หรือติดต่อผู้ดูแลระบบไอทีของคุณ"
			}
		}
	},
	"feedback": {
		"successMessage": "ส่งความคิดเห็นเรียบร้อยแล้ว ขอบคุณ!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "คุณชอบอะไร และมีอะไรที่ควรปรับปรุงบ้าง เราปรับปรุงแพลตฟอร์มทุกวัน และทีมงานอ่านความคิดเห็นทุกข้อความ ขอบคุณ!",
			"title": "แบ่งปันความคิดเห็นของคุณ",
			"body": "คุณชอบอะไร และมีอะไรที่ควรปรับปรุงบ้าง เราปรับปรุงแพลตฟอร์มทุกวัน และทีมงานอ่านความคิดเห็นทุกข้อความ **ขอบคุณ!**",
			"positiveBody": "เราดีใจที่สิ่งนี้เป็นประโยชน์กับคุณ! บอกเราหน่อยว่า**คุณชอบตรงไหน**",
			"negativeBody": "ช่วยบอกเราว่ามีอะไรผิดพลาด เพื่อที่เราจะได้**ปรับปรุงคำตอบให้ดีขึ้น**",
			"placeholder": "กรอกความคิดเห็น",
			"cta": "ส่งความคิดเห็น"
		},
		"report": {
			"title": "ส่งรายงาน",
			"body": "ช่วยบอกเราว่าคำตอบนี้มีปัญหาอะไร",
			"cta": "ส่งรายงาน"
		},
		"suggestCorrection": {
			"title": "เสนอการแก้ไข",
			"body": "ช่วยเราปรับปรุงความถูกต้องของเนื้อหานี้ด้วยการ**รายงานข้อผิดพลาดที่พบ**",
			"cta": "ส่ง"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "ไม่ถูกต้อง",
					"description": "คำตอบมีข้อมูลที่ไม่ถูกต้อง"
				},
				"notHelpful": {
					"title": "ไม่เป็นประโยชน์",
					"description": "คำตอบไม่ได้ตอบคำถามของฉัน"
				},
				"incomplete": {
					"title": "ไม่ครบถ้วน",
					"description": "คำตอบขาดรายละเอียดสำคัญ"
				},
				"hardToUnderstand": {
					"title": "เข้าใจยาก",
					"description": "คำตอบสับสนหรือไม่ชัดเจน"
				},
				"other": {
					"title": "อื่น ๆ",
					"description": "เหตุผลอื่น"
				}
			},
			"report": {
				"misinformation": {
					"title": "ข้อมูลบิดเบือน",
					"description": "คำตอบมีข้อมูลเท็จหรือทำให้เข้าใจผิด"
				},
				"harmfulContent": {
					"title": "เนื้อหาที่เป็นอันตรายหรือไม่เหมาะสม",
					"description": "ถ้อยคำสร้างความเกลียดชัง การคุกคาม หรือภาษาที่ไม่เหมาะสม"
				},
				"violatesPolicies": {
					"title": "ละเมิดนโยบาย",
					"description": "สแปม การโปรโมตตัวเอง หรือเนื้อหาที่ผิดกฎหมาย"
				},
				"other": {
					"title": "อื่น ๆ",
					"description": "อธิบายปัญหาที่พบด้วยคำพูดของคุณเอง"
				}
			}
		},
		"faqs": {
			"title": "คำถามที่พบบ่อย",
			"body": "นี่คือคำถามที่พบบ่อยที่สุดเกี่ยวกับแอป หากคุณมีคำถามอื่น ๆ กรุณาติดต่อเราที่ support@memorang.ai"
		},
		"delete": {
			"title": "ลบบัญชี",
			"body": "เราเสียดายที่คุณจะจากไป และขอให้คุณโชคดีกับเส้นทางการเรียนและการทำงานต่อไป!",
			"options": "ราคาสูงเกินไป|ฉันสอบไปแล้ว|ไม่ชอบเนื้อหา|ขาดฟีเจอร์ที่ต้องการ|อื่น ๆ",
			"confirmdelete": {
				"title": "ยืนยันการลบบัญชี",
				"cta": "ลบ",
				"errorMessage": "ขออภัย อีเมลนี้ไม่ตรงกับบัญชีนี้ กรุณาลองใหม่อีกครั้ง",
				"successMessage": "ลบบัญชีเรียบร้อยแล้ว!",
				"validEmail": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง"
			}
		}
	},
	"recorder": {
		"tapToRecord": "แตะเพื่อบันทึกคำตอบของคุณ",
		"responseAudioUnavailable": "ไม่สามารถเล่นเสียงคำตอบได้",
		"recording": "กำลังบันทึกเสียง",
		"recordingCompleted": "บันทึกเสียงเสร็จสิ้น",
		"getReady": "เตรียมตัว",
		"timeIsUp": "หมดเวลาแล้ว คำตอบของคุณไม่ได้ถูกบันทึกไว้",
		"alert": {
			"title": "ถึงระยะเวลาสูงสุดแล้ว",
			"body": "การบันทึกเสียงหยุดลงเนื่องจากถึงระยะเวลาสูงสุด {{maxDuration}} วินาที"
		},
		"uiElementPressed": "การบันทึกเสียงหยุดลง - มีการเปิดสื่อประกอบคำถามระหว่างที่กำลังบันทึกเสียง"
	},
	"writing": {
		"placeholder": "เขียนคำตอบของคุณที่นี่...",
		"wordCount": "{{count}} {{word}}",
		"title": "คำตอบของคุณ",
		"submit": "ส่ง",
		"helper": {
			"range": "เขียน {{min}}–{{max}} คำเพื่อส่งคำตอบของคุณ",
			"min": "เขียนอย่างน้อย {{min}} คำเพื่อส่งคำตอบของคุณ",
			"max": "กรุณาย่อคำตอบของคุณให้เหลือไม่เกิน {{max}} คำ"
		}
	},
	"navbar": {
		"home": "หน้าแรก",
		"progress": "ความคืบหน้า",
		"insights": "ข้อมูลเชิงลึก",
		"leaderboard": "อันดับ",
		"store": "ร้านค้า",
		"more": "เพิ่มเติม",
		"redeem": "แลกรับสิทธิ์",
		"study-pack": "ชุดการเรียน",
		"podcasts": "พอดแคสต์",
		"modules": "โมดูล",
		"account": "การตั้งค่าบัญชี",
		"accountTab": "บัญชี",
		"privacy": "ความเป็นส่วนตัว",
		"terms": "ข้อกำหนด",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "ป้อนรหัสถูกต้องแล้วแต่ยังมีปัญหาอยู่ใช่ไหม? **ติดต่อฝ่ายสนับสนุน** และอย่าลืมแนบรหัสการเข้าถึงและรายละเอียดการสั่งซื้อของคุณ",
		"olxDialog": {
			"unlockedTitle": "ปลดล็อกการเข้าถึงแล้ว",
			"expiredTitle": "การเข้าถึงหมดอายุแล้ว",
			"testInfo": "**การสอบ:** {{examName}} | **แบบทดสอบ:** {{bundleName}}",
			"upcomingBody_one": "การเข้าถึงแบบทดสอบ OLX ของคุณถูกปลดล็อกแล้ว!\n\nคุณสามารถเริ่มเซสชันได้ในอีก **{{count}} วัน** โปรดกลับมาตรวจสอบอีกครั้งภายหลังเพื่อเริ่มเซสชันของคุณจากแท็บแบบทดสอบฝึกฝน",
			"upcomingBody_other": "การเข้าถึงแบบทดสอบ OLX ของคุณถูกปลดล็อกแล้ว!\n\nคุณสามารถเริ่มเซสชันได้ในอีก **{{count}} วัน** โปรดกลับมาตรวจสอบอีกครั้งภายหลังเพื่อเริ่มเซสชันของคุณจากแท็บแบบทดสอบฝึกฝน",
			"activeBody": "ตอนนี้การเข้าถึงแบบทดสอบ OLX ของคุณเปิดใช้งานแล้ว!\n\nคุณสามารถเริ่มเซสชันได้ทุกเมื่อก่อนวันที่ **{{date}}**\n\nคุณต้องการเริ่มเซสชันตอนนี้หรือไว้ทีหลัง?",
			"expiredBody": "การเข้าถึงแบบทดสอบ OLX ของคุณหมดอายุแล้วเมื่อวันที่ **{{date}}**\n\nโปรดติดต่ออาจารย์หรือผู้ดูแลระบบของโรงเรียนเพื่อขอความช่วยเหลือเพิ่มเติม",
			"startNowCta": "เริ่มตอนนี้",
			"startLaterCta": "เริ่มทีหลัง"
		},
		"unexpectedError": "เกิดข้อผิดพลาดที่ไม่คาดคิด"
	},
	"redeemCode": {
		"titleRedeem": "แลกรับสิทธิ์การใช้งาน",
		"titleGranted": "เปิดสิทธิ์การใช้งานแล้ว",
		"formTitle": "กรอกรหัสเข้าใช้งานของคุณ",
		"accessCodeHint": "หากคุณมีรหัสเข้าใช้งาน กรุณากรอกที่นี่ โดยใส่เครื่องหมายขีดด้วย",
		"submit": "แลกรับสิทธิ์",
		"access": "เข้าใช้งานที่นี่",
		"helpFindCode": "ต้องการความช่วยเหลือในการหารหัสของคุณไหม",
		"troubleRedeeming": "แลกรับสิทธิ์ไม่สำเร็จใช่ไหม ลองถามผู้ช่วยดูสิ!",
		"skipStep": "ข้ามขั้นตอนนี้"
	},
	"autoRedeem": {
		"redeem": "แลกรับสิทธิ์",
		"redeeming": "กำลังแลกรับสิทธิ์...",
		"continue": "ดำเนินการต่อ",
		"unredeemedPrompt_one": "มี**ผลิตภัณฑ์ {{count}} รายการ**ที่ผูกกับอีเมล **{{email}}** ซึ่งยังไม่ได้แลกรับสิทธิ์ คุณต้องการเพิ่มเข้าบัญชีของคุณไหม",
		"unredeemedPrompt_other": "มี**ผลิตภัณฑ์ {{count}} รายการ**ที่ผูกกับอีเมล **{{email}}** ซึ่งยังไม่ได้แลกรับสิทธิ์ คุณต้องการเพิ่มเข้าบัญชีของคุณไหม",
		"successMessage_one": "ยินดีด้วย! **ผลิตภัณฑ์**ด้านล่างถูกปลดล็อกในบัญชีของคุณแล้ว หลังจากกดดำเนินการต่อ บริบทของแอปจะเปลี่ยนไปตามการสอบ: **{{examName}}** คุณสามารถเปลี่ยนได้ทุกเมื่อในการตั้งค่าบัญชี หากต้องการเตรียมสอบรายการอื่นหรือซื้อผลิตภัณฑ์อื่น",
		"successMessage_other": "ยินดีด้วย! **ผลิตภัณฑ์ {{count}} รายการ**ด้านล่างถูกปลดล็อกในบัญชีของคุณแล้ว หลังจากกดดำเนินการต่อ บริบทของแอปจะเปลี่ยนไปตามการสอบ: **{{examName}}** คุณสามารถเปลี่ยนได้ทุกเมื่อในการตั้งค่าบัญชี หากต้องการเตรียมสอบรายการอื่นหรือซื้อผลิตภัณฑ์อื่น"
	},
	"olxEligibility": {
		"goToPracticeTests": "ไปที่ข้อสอบเสมือนจริง"
	},
	"moreChallenges": {
		"challenges": "ความท้าทาย",
		"challengesCount": "{{value}} ความท้าทาย"
	},
	"tts": {
		"tooltip": "ฟัง"
	},
	"commandBar": {
		"placeholder": "ค้นหา...",
		"input": {
			"placeholder": "พิมพ์คำสั่งหรือค้นหา"
		},
		"sections": {
			"quickActions": "การดำเนินการด่วน"
		},
		"actions": {
			"changeExam": "เปลี่ยนการสอบ",
			"switchToDarkMode": "สลับเป็นโหมดมืด",
			"switchToLightMode": "สลับเป็นโหมดสว่าง",
			"setExamDate": "ตั้งวันสอบ"
		}
	},
	"filterView": {
		"placeholder": "ค้นหาการสอบ..."
	},
	"transcript": {
		"show": "แสดงบทถอดเสียง",
		"hide": "ซ่อนบทถอดเสียง"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "โลโก้แอป",
			"testNameLabel": "ชื่อข้อสอบ",
			"sectionLabel": "ส่วน",
			"back": "ย้อนกลับ",
			"pause": "หยุดชั่วคราว",
			"menuLabel": "ตัวเลือกเพิ่มเติม"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "ความคืบหน้าของข้อสอบ",
			"of": "จาก",
			"pauseSession": "หยุดเซสชันชั่วคราว",
			"timerTooltip": {
				"item": "เวลาที่เหลือสำหรับคำถามนี้",
				"section": "เวลาที่เหลือในส่วนนี้",
				"test": "เวลาที่เหลือในข้อสอบชุดนี้"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "ถัดไป"
		},
		"progressBar": {
			"timeLeftLabel": "เวลาที่เหลือสำหรับคำถามนี้",
			"timeLeftForUnit": "เวลาที่เหลือสำหรับหน่วยนี้",
			"questionOf": "คำถามที่ {{current}} จาก {{total}}",
			"questionProgress": "<b>{{current}}</b> จาก {{total}}",
			"timesUp": "หมดเวลา",
			"statusTooltips": {
				"answered": "ตอบแล้ว",
				"inProgress": "กำลังทำอยู่",
				"skipped": "ข้ามแล้ว",
				"notSeen": "ยังไม่ได้ดู"
			}
		},
		"timeRemainingDialog": {
			"title": "คุณยังมีเวลาเหลือ",
			"body": "ยังมีเวลาเหลือในหน่วยนี้ คุณต้องการทบทวนคำตอบก่อนส่งไหม",
			"reviewCta": "ทบทวนคำตอบของฉัน"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "ต้นฉบับ",
				"answerTitle": "คำตอบของคุณ",
				"remainingBadge": "เหลืออีก {{count}}",
				"placedBadge": "วางแล้ว {{count}}",
				"pointsBadge": "{{earned}}/{{max}} คะแนน",
				"emptyHint": "ลากย่อหน้าจากแผงด้านซ้ายมาวางที่นี่"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "ข้อมูลฝ่ายสนับสนุน",
			"emailLabel": "อีเมล",
			"subjectLabel": "เรื่อง",
			"messageBodyLabel": "เนื้อหาข้อความ",
			"appDetailsLabel": "รายละเอียดแอป",
			"appNameLabel": "ชื่อ",
			"versionLabel": "เวอร์ชัน",
			"platformLabel": "แพลตฟอร์ม"
		},
		"chat": {
			"assistantTitle": "ผู้ช่วยฝ่ายสนับสนุนของ {{tenantName}}",
			"fallbackTitle": "แชท",
			"betaWarning": "ผู้ช่วย AI นี้อยู่ในเวอร์ชัน **เบต้า** — คำตอบอาจไม่ถูกต้องหรือไม่สมบูรณ์เป็นบางครั้ง",
			"greeting": "สวัสดีครับ/ค่ะ 👋 คุณกำลังมีปัญหาในการเข้าถึงผลิตภัณฑ์อยู่หรือเปล่า? ฉันพร้อมช่วยเหลือคุณ! ก่อนอื่นมาระบุปัญหากันก่อน ข้อใดต่อไปนี้ตรงกับสถานการณ์ของคุณมากที่สุด\n\n1. ฉันมีรหัสการเข้าถึง แต่ดูเหมือนจะใช้งานไม่ได้\n2. ฉันซื้อสินค้าแล้ว แต่หารหัสการเข้าถึงไม่เจอ\n3. ฉันควรได้รับสิทธิ์เข้าถึงผ่านทางโรงเรียนของฉัน แต่หารหัสการเข้าถึงไม่เจอ\n4. ก่อนหน้านี้ฉันเคยเข้าถึงผลิตภัณฑ์ได้ แต่ตอนนี้เข้าถึงไม่ได้แล้ว\n\nกรุณาป้อนหมายเลขที่ตรงกับปัญหาของคุณ",
			"input": {
				"label": "พิมพ์ข้อความ...",
				"sendLabel": "ส่ง"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 แลกรับสิทธิ์สำเร็จ",
			"previouslyRedeemedTitle": "🚀 เคยแลกรับสิทธิ์แล้ว",
			"subtitle": "เข้าถึงเนื้อหาของคุณได้ที่นี่",
			"expires": "หมดอายุ: {{date}}",
			"openCta": "เปิด"
		},
		"purchases": {
			"title": "🎉 พบรหัสการเข้าถึง",
			"subtitle": "แลกรับสิทธิ์เพื่อเข้าถึงเนื้อหาของคุณ",
			"accessCodesLabel_one": "รหัสการเข้าถึง",
			"accessCodesLabel_other": "รหัสการเข้าถึง",
			"moreCodes_one": "(+ อีก {{count}} รายการ)",
			"moreCodes_other": "(+ อีก {{count}} รายการ)",
			"featuresLabel": "ฟีเจอร์",
			"redeemCta": "แลกรับสิทธิ์"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "มีเวอร์ชันใหม่พร้อมใช้งาน กรุณาคลิกรีเฟรชเพื่ออัปเดต",
			"refreshCta": "รีเฟรช",
			"refreshA11yLabel": "รีเฟรชเพื่ออัปเดตแอป",
			"dismissTooltip": "ปิด",
			"dismissA11yLabel": "ปิดการแจ้งเตือนการอัปเดต"
		}
	},
	"cme": {
		"type": "ประเภท CME",
		"chooseExportMethod": "เลือกวิธีการส่งออก",
		"selectDateRange": "เลือกช่วงวันที่",
		"from": "จาก",
		"to": "ถึง",
		"sendPdfTo": "ส่ง PDF ไปยัง {{email}}",
		"downloadCertificate": "ดาวน์โหลดใบรับรองเป็น PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "รับเครดิต CME",
		"confirmYourName": "ยืนยันชื่อของคุณ",
		"certificateNameNotice": "ชื่อนี้จะถูกพิมพ์บนใบรับรอง CME ของคุณ",
		"firstName": "ชื่อจริง",
		"lastName": "นามสกุล",
		"firstNamePlaceholder": "ป้อนชื่อจริงของคุณ",
		"lastNamePlaceholder": "ป้อนนามสกุลของคุณ",
		"confirm": "ยืนยัน",
		"creditsEarnedTitle": "CME ที่ได้รับ",
		"creditRatioCaption": "12 ความท้าทาย = 1 เครดิต CME",
		"earned": "ได้รับ",
		"available": "ว่าง",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "ส่งออกใบรับรอง CME",
		"exportDisabledCaption": "คุณต้องได้รับเครดิต CME อย่างน้อย 1 ระดับเพื่อส่งออกใบรับรองของคุณ",
		"viewDisclaimer": "ดูข้อจำกัดความรับผิด CME"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "คำอธิบาย",
			"tagsHeading": "แท็ก",
			"citationsHeading": "เอกสารอ้างอิง",
			"playing": "กำลังเล่น"
		},
		"a11y": {
			"artwork": "ภาพปกของ {{title}}",
			"playEpisode": "เล่นตอนนี้ {{duration}}",
			"pauseEpisode": "หยุดตอนชั่วคราว",
			"play": "เล่น",
			"pause": "หยุดชั่วคราว",
			"addToQueue": "เพิ่มในคิว",
			"removeFromQueue": "นำออกจากคิว",
			"addBookmark": "บุ๊กมาร์ก",
			"removeBookmark": "นำบุ๊กมาร์กออก",
			"seekBar": "แถบเลื่อนตำแหน่ง",
			"skipPrevious": "ข้ามไปแทร็กก่อนหน้า",
			"skipNext": "ข้ามไปแทร็กถัดไป",
			"rewind": "ย้อนกลับ {{seconds}} วินาที",
			"fastForward": "เดินหน้า {{seconds}} วินาที",
			"playbackSpeed": "ความเร็วการเล่น {{speed}}x"
		}
	}
}
